{
  "resourceType": "Bundle",
  "type": "searchset",
  "total": 256,
  "link": [
    {
      "relation": "self",
      "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation?category=laboratory&_count=1000&patient=e.Evi4toMFqPiXu0iCJJ3MA3"
    }
  ],
  "entry": [
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUIRjFF6TXzQmNQUq4X8pKzYjjXNQ3UUiCv6AZN7t7Z3hx2SCuYvtmDBuVvojGlyw3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUIRjFF6TXzQmNQUq4X8pKzYjjXNQ3UUiCv6AZN7t7Z3hx2SCuYvtmDBuVvojGlyw3",
      "resource": {
        "resourceType": "Observation",
        "id": "eUIRjFF6TXzQmNQUq4X8pKzYjjXNQ3UUiCv6AZN7t7Z3hx2SCuYvtmDBuVvojGlyw3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eInGP3M.nEn3Z.oa.IekVVA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "QC OPTOCHIN DISC LOT #" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 7.1,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 6.4,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "3.8 - 6.4 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAOOnD20DH7BbocoaHkR.myYzNOzVdqg-aH1k.Rt8Sat83"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAOOnD20DH7BbocoaHkR.myYzNOzVdqg-aH1k.Rt8Sat83",
      "resource": {
        "resourceType": "Observation",
        "id": "eBScTcqxI2dsc3wbHZ0cZAOOnD20DH7BbocoaHkR.myYzNOzVdqg-aH1k.Rt8Sat83",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEd5aqiFPIVecYrPAEWIUEQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:30:34Z",
        "valueQuantity": {
          "value": 28,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 24,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 32,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "24 - 32 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AaZu59I9ygFATV415gWkH6QSiQ2CTWlJCp184LJ92OHKg3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AaZu59I9ygFATV415gWkH6QSiQ2CTWlJCp184LJ92OHKg3",
      "resource": {
        "resourceType": "Observation",
        "id": "ePdjCrNz2KcTr2Rnae.4AaZu59I9ygFATV415gWkH6QSiQ2CTWlJCp184LJ92OHKg3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eB5nqBicqmsZeCHplNzhy7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 27,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 24,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 32,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "24 - 32 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRGQ0T82colTSQXY9ha2hehRpwMD9YKbIx9-B1XHvMiBr3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRGQ0T82colTSQXY9ha2hehRpwMD9YKbIx9-B1XHvMiBr3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIiwhgwmsW8Ousqj-LmfKRGQ0T82colTSQXY9ha2hehRpwMD9YKbIx9-B1XHvMiBr3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEEmMzRjlFj4tpgcdygAM7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:38Z",
        "issued": "2006-02-14T22:19:40Z",
        "valueQuantity": {
          "value": 31,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 24,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 32,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "24 - 32 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuWOyXPXT3UuOvSjMNXXG.nPOxhYTBCgQ79j-Z1uCEHU63"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuWOyXPXT3UuOvSjMNXXG.nPOxhYTBCgQ79j-Z1uCEHU63",
      "resource": {
        "resourceType": "Observation",
        "id": "eRoR7q5P-NRZBKPzyLwgnuWOyXPXT3UuOvSjMNXXG.nPOxhYTBCgQ79j-Z1uCEHU63",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4OetgbmmyJUdElq5nV0Kig3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:01Z",
        "valueQuantity": {
          "value": 30,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 25,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 35,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "25 - 35 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vtv7ko1VRWwVklkOix5AXTedmKycdjo.KQJ5qrDcuUkv3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vtv7ko1VRWwVklkOix5AXTedmKycdjo.KQJ5qrDcuUkv3",
      "resource": {
        "resourceType": "Observation",
        "id": "eKHAY5Bp-e0ZN3-OmG481vtv7ko1VRWwVklkOix5AXTedmKycdjo.KQJ5qrDcuUkv3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ezQ7IMnsWQ4LX6RkQDYtxZA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:19:20Z",
        "valueQuantity": {
          "value": 30,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 25,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 35,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "25 - 35 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSO4cgpr48P7Wd6hcMnpm73-orjptzyW-.8HhlSH-b5VA63"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSO4cgpr48P7Wd6hcMnpm73-orjptzyW-.8HhlSH-b5VA63",
      "resource": {
        "resourceType": "Observation",
        "id": "eG9LkyxbHz4pLMCembiWSO4cgpr48P7Wd6hcMnpm73-orjptzyW-.8HhlSH-b5VA63",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e1DmTHSh6fjZHl.iwL1UvwQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 29,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 25,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 35,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "25 - 35 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x3ausNOA436CuUmxOFPgC2f6TOffkVmSMJ4qyFMH4mdL3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x3ausNOA436CuUmxOFPgC2f6TOffkVmSMJ4qyFMH4mdL3",
      "resource": {
        "resourceType": "Observation",
        "id": "erhmvJ47wMUAuUoiBSls8x3ausNOA436CuUmxOFPgC2f6TOffkVmSMJ4qyFMH4mdL3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e7PspqInomYypkaM6thGHiA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 29,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 25,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 35,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "25 - 35 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux6qgKTmGhVPDUiq5khFcKFJTjeoSgQOSBCSaljhtDcrL3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux6qgKTmGhVPDUiq5khFcKFJTjeoSgQOSBCSaljhtDcrL3",
      "resource": {
        "resourceType": "Observation",
        "id": "eujnQ5OQreTwjBUPo9Cvux6qgKTmGhVPDUiq5khFcKFJTjeoSgQOSBCSaljhtDcrL3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eO1Q18BbDJFpjPnNwgTTfOw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 27,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 25,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 35,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "25 - 35 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z7ax4oJ9u5bWV3pQ83nLkpCV7pM4C2nKR.N4am85q9M03"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z7ax4oJ9u5bWV3pQ83nLkpCV7pM4C2nKR.N4am85q9M03",
      "resource": {
        "resourceType": "Observation",
        "id": "ereKB7Ir7tvrPVLzvQHf1Z7ax4oJ9u5bWV3pQ83nLkpCV7pM4C2nKR.N4am85q9M03",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e6QUFcWf-6SF2tLYg7dJ.Fg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e82ervAK3Xu6ba-9SyGsUCg3"
        },
        "effectiveDateTime": "1997-02-17T06:00:00Z",
        "valueQuantity": {
          "value": 27,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 25,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 35,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "25 - 35 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkC3QvwcnFHOwxP2VtHvkyj9Hzgh6TfewYdY2.z7n.3daQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkC3QvwcnFHOwxP2VtHvkyj9Hzgh6TfewYdY2.z7n.3daQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "evZrMLoPaxzj4iA7-VWIkC3QvwcnFHOwxP2VtHvkyj9Hzgh6TfewYdY2.z7n.3daQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ec.w5K7Nw-5HefdYFkkG2WQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bicarb" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 28,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 25,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 35,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "25 - 35 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAOymU6xtnx7-vbWae.775j8O-pm5R0Njg47wB-s-PdiG3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAOymU6xtnx7-vbWae.775j8O-pm5R0Njg47wB-s-PdiG3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBScTcqxI2dsc3wbHZ0cZAOymU6xtnx7-vbWae.775j8O-pm5R0Njg47wB-s-PdiG3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEd5aqiFPIVecYrPAEWIUEQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:30:34Z",
        "valueQuantity": {
          "value": 0.9,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.6,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 0.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.6 - 0.9 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AabpiJyYwL2lBpnTL2IiHVn4N8oGO0qh5nKXzUr53e6sa3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AabpiJyYwL2lBpnTL2IiHVn4N8oGO0qh5nKXzUr53e6sa3",
      "resource": {
        "resourceType": "Observation",
        "id": "ePdjCrNz2KcTr2Rnae.4AabpiJyYwL2lBpnTL2IiHVn4N8oGO0qh5nKXzUr53e6sa3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eB5nqBicqmsZeCHplNzhy7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 1.1,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.6,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 0.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.6 - 0.9 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRDx.HiHCTHfXYubIPMaJ1l7rSj04.HzB4Ll6FRUz10Ts3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRDx.HiHCTHfXYubIPMaJ1l7rSj04.HzB4Ll6FRUz10Ts3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIiwhgwmsW8Ousqj-LmfKRDx.HiHCTHfXYubIPMaJ1l7rSj04.HzB4Ll6FRUz10Ts3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEEmMzRjlFj4tpgcdygAM7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:38Z",
        "issued": "2006-02-14T22:19:40Z",
        "valueQuantity": {
          "value": 1.1,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.6,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 0.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.6 - 0.9 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuVMomOTwYo.Wlas5nlHvB9uAJ75zzHvKIIbJ1p.YOLY93"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuVMomOTwYo.Wlas5nlHvB9uAJ75zzHvKIIbJ1p.YOLY93",
      "resource": {
        "resourceType": "Observation",
        "id": "eRoR7q5P-NRZBKPzyLwgnuVMomOTwYo.Wlas5nlHvB9uAJ75zzHvKIIbJ1p.YOLY93",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4OetgbmmyJUdElq5nV0Kig3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:01Z",
        "valueQuantity": {
          "value": 1.2,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.6,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 0.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.6 - 0.9 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vqC-yURFnWTG1d9a.5t2wvyPVS18uKzQbMx1mLRcF.rQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vqC-yURFnWTG1d9a.5t2wvyPVS18uKzQbMx1mLRcF.rQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "eKHAY5Bp-e0ZN3-OmG481vqC-yURFnWTG1d9a.5t2wvyPVS18uKzQbMx1mLRcF.rQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ezQ7IMnsWQ4LX6RkQDYtxZA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:19:20Z",
        "valueQuantity": {
          "value": 1.3,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.8,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 1.2,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.8 - 1.2 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSO78ZEMLLBQG.r6cLwwgd2my76idEitb-.NUZh8-RGbGd3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSO78ZEMLLBQG.r6cLwwgd2my76idEitb-.NUZh8-RGbGd3",
      "resource": {
        "resourceType": "Observation",
        "id": "eG9LkyxbHz4pLMCembiWSO78ZEMLLBQG.r6cLwwgd2my76idEitb-.NUZh8-RGbGd3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e1DmTHSh6fjZHl.iwL1UvwQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 1.2,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.8,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 1.2,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.8 - 1.2 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x1HHpewGcpHsHYzmF-y99iNAZIRAjEusgMMsxDS8OChQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x1HHpewGcpHsHYzmF-y99iNAZIRAjEusgMMsxDS8OChQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "erhmvJ47wMUAuUoiBSls8x1HHpewGcpHsHYzmF-y99iNAZIRAjEusgMMsxDS8OChQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e7PspqInomYypkaM6thGHiA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 1.2,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.8,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 1.2,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.8 - 1.2 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux3.Wd6sKIoE-yJZtbWxBpX7so6wZrkD9jQU5g.QZmF8a3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux3.Wd6sKIoE-yJZtbWxBpX7so6wZrkD9jQU5g.QZmF8a3",
      "resource": {
        "resourceType": "Observation",
        "id": "eujnQ5OQreTwjBUPo9Cvux3.Wd6sKIoE-yJZtbWxBpX7so6wZrkD9jQU5g.QZmF8a3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eO1Q18BbDJFpjPnNwgTTfOw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 1.3,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.8,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 1.2,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.8 - 1.2 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z12XZDAeq1rA0cvWAiMdaWgYqntchU.0FyahbMcISDtP3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z12XZDAeq1rA0cvWAiMdaWgYqntchU.0FyahbMcISDtP3",
      "resource": {
        "resourceType": "Observation",
        "id": "ereKB7Ir7tvrPVLzvQHf1Z12XZDAeq1rA0cvWAiMdaWgYqntchU.0FyahbMcISDtP3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e6QUFcWf-6SF2tLYg7dJ.Fg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e82ervAK3Xu6ba-9SyGsUCg3"
        },
        "effectiveDateTime": "1997-02-17T06:00:00Z",
        "valueQuantity": {
          "value": 1.1,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.8,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 1.2,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.8 - 1.2 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkCxF42YrQzSIzZ0gvItXhC0DAdOs.HDxB54gPV4w3P-6v3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkCxF42YrQzSIzZ0gvItXhC0DAdOs.HDxB54gPV4w3P-6v3",
      "resource": {
        "resourceType": "Observation",
        "id": "evZrMLoPaxzj4iA7-VWIkCxF42YrQzSIzZ0gvItXhC0DAdOs.HDxB54gPV4w3P-6v3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ec.w5K7Nw-5HefdYFkkG2WQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2160-0",
              "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Creatinine, Ser"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 1.2,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0.8,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 1.2,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "0.8 - 1.2 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAOymU6xtnx7-vbWae.775j9BHZknx5BR9mcjb898wd.b3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAOymU6xtnx7-vbWae.775j9BHZknx5BR9mcjb898wd.b3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBScTcqxI2dsc3wbHZ0cZAOymU6xtnx7-vbWae.775j9BHZknx5BR9mcjb898wd.b3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEd5aqiFPIVecYrPAEWIUEQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Glucose" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:30:34Z",
        "valueQuantity": {
          "value": 100,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 74,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 106,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "74 - 106 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AabpiJyYwL2lBpnTL2IiHVn5YB07U8-AhPZ41mU4soc1n3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AabpiJyYwL2lBpnTL2IiHVn5YB07U8-AhPZ41mU4soc1n3",
      "resource": {
        "resourceType": "Observation",
        "id": "ePdjCrNz2KcTr2Rnae.4AabpiJyYwL2lBpnTL2IiHVn5YB07U8-AhPZ41mU4soc1n3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eB5nqBicqmsZeCHplNzhy7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Glucose" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 95,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 70,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 100,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "70 - 100 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRDx.HiHCTHfXYubIPMaJ1l5E6v6XnfU4ZvBVpXSTIeIs3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRDx.HiHCTHfXYubIPMaJ1l5E6v6XnfU4ZvBVpXSTIeIs3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIiwhgwmsW8Ousqj-LmfKRDx.HiHCTHfXYubIPMaJ1l5E6v6XnfU4ZvBVpXSTIeIs3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEEmMzRjlFj4tpgcdygAM7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Glucose" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:38Z",
        "issued": "2006-02-14T22:19:40Z",
        "valueQuantity": {
          "value": 98,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 70,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 100,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "70 - 100 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9OnUJknzb23BapxKuE7yhBZOEFtZVMECwpXCIprlPhF9T3IMcS9PCV02jbwTlkmk3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9OnUJknzb23BapxKuE7yhBZOEFtZVMECwpXCIprlPhF9T3IMcS9PCV02jbwTlkmk3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9OnUJknzb23BapxKuE7yhBZOEFtZVMECwpXCIprlPhF9T3IMcS9PCV02jbwTlkmk3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e3sHfa2ZCV2ia8D7XmPVfaA3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Glucose" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:04Z",
        "valueQuantity": {
          "value": 100,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 70,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 100,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "70 - 100 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edjq6Jv0PFWglY4R5O8GD35Ed1aI5hKQ3xqA0lxOrfRY4Q6yylYmxSWuNBZ9T-csi3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edjq6Jv0PFWglY4R5O8GD35Ed1aI5hKQ3xqA0lxOrfRY4Q6yylYmxSWuNBZ9T-csi3",
      "resource": {
        "resourceType": "Observation",
        "id": "edjq6Jv0PFWglY4R5O8GD35Ed1aI5hKQ3xqA0lxOrfRY4Q6yylYmxSWuNBZ9T-csi3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/efK5fU1n54keHQkilYxOZJQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Glucose" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:19:45Z",
        "valueQuantity": {
          "value": 100,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 70,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 100,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "70 - 100 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ezu7Htupe9Y6WkKOIHDhCRw7vEkUiOFtZizbkqrhzLQqOCJ1eTm0v4CO.18uYSFJd3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ezu7Htupe9Y6WkKOIHDhCRw7vEkUiOFtZizbkqrhzLQqOCJ1eTm0v4CO.18uYSFJd3",
      "resource": {
        "resourceType": "Observation",
        "id": "ezu7Htupe9Y6WkKOIHDhCRw7vEkUiOFtZizbkqrhzLQqOCJ1eTm0v4CO.18uYSFJd3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eFm1Fo1MJsHQ7YFJ8ydtFDw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Glucose" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 110,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 70,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 100,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "70 - 100 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e46falvtiJ3fZD4WYYQx5gtrOF9RLGW2uIEjFTUpo9-NwE2avFvBce8huy9zuyk553"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e46falvtiJ3fZD4WYYQx5gtrOF9RLGW2uIEjFTUpo9-NwE2avFvBce8huy9zuyk553",
      "resource": {
        "resourceType": "Observation",
        "id": "e46falvtiJ3fZD4WYYQx5gtrOF9RLGW2uIEjFTUpo9-NwE2avFvBce8huy9zuyk553",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4Eud-UFRn6uA0dfzsnh05Q3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:26:06Z",
        "valueQuantity": {
          "value": 48,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 40,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 60,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "40 - 60 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBWxoeKluAbdkMY44S-5UzZx3AE68W.btHTGBkFLBGM.DslancMce.vbTfaiMEcpO3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBWxoeKluAbdkMY44S-5UzZx3AE68W.btHTGBkFLBGM.DslancMce.vbTfaiMEcpO3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBWxoeKluAbdkMY44S-5UzZx3AE68W.btHTGBkFLBGM.DslancMce.vbTfaiMEcpO3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ePq0POYKaS94UBkE6QyeZXQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e3VeK6AZWFtb7l5Tr-3QB0Q3"
        },
        "effectiveDateTime": "2007-11-23T19:43:00Z",
        "issued": "2010-05-27T14:39:26Z",
        "valueQuantity": {
          "value": 50,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 40,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 60,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "40 - 60 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/egDfTe8Ttfro99n0e.PLzgB3Pcs0tQzfdjYJYbpw3WKVSUxZvZJ0Hwiq41dZJfU1z3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/egDfTe8Ttfro99n0e.PLzgB3Pcs0tQzfdjYJYbpw3WKVSUxZvZJ0Hwiq41dZJfU1z3",
      "resource": {
        "resourceType": "Observation",
        "id": "egDfTe8Ttfro99n0e.PLzgB3Pcs0tQzfdjYJYbpw3WKVSUxZvZJ0Hwiq41dZJfU1z3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eGK2VygBaD-ioEYSug7SKNA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 41,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 40,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 60,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "40 - 60 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/efZqLa2S8LHILH9odWpC.s809W9QMMUtpX9-QxZyebDO7gS-jfoX7TaeXDBwBGF3X3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/efZqLa2S8LHILH9odWpC.s809W9QMMUtpX9-QxZyebDO7gS-jfoX7TaeXDBwBGF3X3",
      "resource": {
        "resourceType": "Observation",
        "id": "efZqLa2S8LHILH9odWpC.s809W9QMMUtpX9-QxZyebDO7gS-jfoX7TaeXDBwBGF3X3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eQHrh3MszP6taSvdTTp.dSg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:04Z",
        "issued": "2006-02-14T22:19:07Z",
        "valueQuantity": {
          "value": 40,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 85,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 85 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eVed6wQtsoO4YHNXMMjadUJHLs2CTKiSoBOim7S9eS1dlebw8zghca8CjqhnR1Rsm3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eVed6wQtsoO4YHNXMMjadUJHLs2CTKiSoBOim7S9eS1dlebw8zghca8CjqhnR1Rsm3",
      "resource": {
        "resourceType": "Observation",
        "id": "eVed6wQtsoO4YHNXMMjadUJHLs2CTKiSoBOim7S9eS1dlebw8zghca8CjqhnR1Rsm3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ehsu6g35pwjBgGNqxj4ptGg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiJlN4Pb62jWsEohoUA0bFA3"
        },
        "effectiveDateTime": "2005-02-14T06:00:00Z",
        "issued": "2005-11-04T17:52:02Z",
        "valueQuantity": {
          "value": 42,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 85,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 85 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRn62f2gvJ1SVSpGCpNLdooa6SBtdjV7xcDZEhy-7T8Go5e62OJKrHhKR.gO7OEr13"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRn62f2gvJ1SVSpGCpNLdooa6SBtdjV7xcDZEhy-7T8Go5e62OJKrHhKR.gO7OEr13",
      "resource": {
        "resourceType": "Observation",
        "id": "eRn62f2gvJ1SVSpGCpNLdooa6SBtdjV7xcDZEhy-7T8Go5e62OJKrHhKR.gO7OEr13",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e8KLPfEVRCShb5ThN1ojPyw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T20:30:00Z",
        "issued": "2005-11-04T17:54:16Z",
        "valueQuantity": {
          "value": 45,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 85,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 85 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e4P0cXNVqNCQAEy3O83lHeJxfHanCPvjrHakhHzYS2Wb.UBGfkOUmO2L5x3CciTPt3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e4P0cXNVqNCQAEy3O83lHeJxfHanCPvjrHakhHzYS2Wb.UBGfkOUmO2L5x3CciTPt3",
      "resource": {
        "resourceType": "Observation",
        "id": "e4P0cXNVqNCQAEy3O83lHeJxfHanCPvjrHakhHzYS2Wb.UBGfkOUmO2L5x3CciTPt3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eaGrrrRhNipyoS-JW5YCjXQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T23:20:16Z",
        "issued": "2005-10-22T23:20:25Z",
        "valueQuantity": {
          "value": 44,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 70,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 70 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ekX0lytcSqyi9C5WuVJhshMxprZ10mdd6zE0r37hoIK035-2H58N-iQkcRswPfCnl3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ekX0lytcSqyi9C5WuVJhshMxprZ10mdd6zE0r37hoIK035-2H58N-iQkcRswPfCnl3",
      "resource": {
        "resourceType": "Observation",
        "id": "ekX0lytcSqyi9C5WuVJhshMxprZ10mdd6zE0r37hoIK035-2H58N-iQkcRswPfCnl3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eE5Mv0vyHb8zg3lht3sfI2A3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 46,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 70,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 70 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ec112UpEeRdZdwkoaI2f9EJpx9-bOYYsoZmcJ4gBEGuKl9ILg.f9foMxSse1BD51Y3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ec112UpEeRdZdwkoaI2f9EJpx9-bOYYsoZmcJ4gBEGuKl9ILg.f9foMxSse1BD51Y3",
      "resource": {
        "resourceType": "Observation",
        "id": "ec112UpEeRdZdwkoaI2f9EJpx9-bOYYsoZmcJ4gBEGuKl9ILg.f9foMxSse1BD51Y3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eY0VqIHb5La3Z3ojQmQ0d0w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/exiGZVCla2tHmIX5raZ9-rQ3"
        },
        "effectiveDateTime": "1999-10-01T05:00:00Z",
        "valueQuantity": {
          "value": 51,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 70,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 70 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edsaYNxj2GuldmyQ-tYdIgxhVNNJyOj-uibuN9PGIbxMRq8rlhmkIjMva9yWdJCp33"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edsaYNxj2GuldmyQ-tYdIgxhVNNJyOj-uibuN9PGIbxMRq8rlhmkIjMva9yWdJCp33",
      "resource": {
        "resourceType": "Observation",
        "id": "edsaYNxj2GuldmyQ-tYdIgxhVNNJyOj-uibuN9PGIbxMRq8rlhmkIjMva9yWdJCp33",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ehHCQluwCweffaNbykSJUCw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 41,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 70,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 70 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ek1bE1ctAYp6espBg9reBh3ltgWuO6p2S087zEpwiLz884F9rNake4fIROIEVgX5v3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ek1bE1ctAYp6espBg9reBh3ltgWuO6p2S087zEpwiLz884F9rNake4fIROIEVgX5v3",
      "resource": {
        "resourceType": "Observation",
        "id": "ek1bE1ctAYp6espBg9reBh3ltgWuO6p2S087zEpwiLz884F9rNake4fIROIEVgX5v3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eBXyRMGLE2miDvhpUU8et6A3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 42,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 70,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 70 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e5Vrgx0NtoZVXAmKau.-ju5Jcs1kMrFij6r6WO7hGUqazJJT61MPMMe7s-4TAlt.G3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e5Vrgx0NtoZVXAmKau.-ju5Jcs1kMrFij6r6WO7hGUqazJJT61MPMMe7s-4TAlt.G3",
      "resource": {
        "resourceType": "Observation",
        "id": "e5Vrgx0NtoZVXAmKau.-ju5Jcs1kMrFij6r6WO7hGUqazJJT61MPMMe7s-4TAlt.G3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/es0UW1C-HAnJgqwAg9t1BEQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "HDL-2" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 45,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 70,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 70 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e46falvtiJ3fZD4WYYQx5gtrOF9RLGW2uIEjFTUpo9-ONbPfQKVnj2nSbjhGYAwFY3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e46falvtiJ3fZD4WYYQx5gtrOF9RLGW2uIEjFTUpo9-ONbPfQKVnj2nSbjhGYAwFY3",
      "resource": {
        "resourceType": "Observation",
        "id": "e46falvtiJ3fZD4WYYQx5gtrOF9RLGW2uIEjFTUpo9-ONbPfQKVnj2nSbjhGYAwFY3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4Eud-UFRn6uA0dfzsnh05Q3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:26:06Z",
        "valueQuantity": {
          "value": 99,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 50,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 100,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "50 - 100 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBWxoeKluAbdkMY44S-5UzZx3AE68W.btHTGBkFLBGM.LlmikV7GrNKYhtYwS1nIM3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBWxoeKluAbdkMY44S-5UzZx3AE68W.btHTGBkFLBGM.LlmikV7GrNKYhtYwS1nIM3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBWxoeKluAbdkMY44S-5UzZx3AE68W.btHTGBkFLBGM.LlmikV7GrNKYhtYwS1nIM3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ePq0POYKaS94UBkE6QyeZXQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e3VeK6AZWFtb7l5Tr-3QB0Q3"
        },
        "effectiveDateTime": "2007-11-23T19:43:00Z",
        "issued": "2010-05-27T14:39:26Z",
        "valueQuantity": {
          "value": 95,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 50,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 100,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "50 - 100 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/egDfTe8Ttfro99n0e.PLzgB3Pcs0tQzfdjYJYbpw3WKXpzp66zx0mXUpsGOdg48hy3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/egDfTe8Ttfro99n0e.PLzgB3Pcs0tQzfdjYJYbpw3WKXpzp66zx0mXUpsGOdg48hy3",
      "resource": {
        "resourceType": "Observation",
        "id": "egDfTe8Ttfro99n0e.PLzgB3Pcs0tQzfdjYJYbpw3WKXpzp66zx0mXUpsGOdg48hy3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eGK2VygBaD-ioEYSug7SKNA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 121,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 50,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 100,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "50 - 100 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/efZqLa2S8LHILH9odWpC.s809W9QMMUtpX9-QxZyebDM93XbL8D6B2qRav-gSsikr3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/efZqLa2S8LHILH9odWpC.s809W9QMMUtpX9-QxZyebDM93XbL8D6B2qRav-gSsikr3",
      "resource": {
        "resourceType": "Observation",
        "id": "efZqLa2S8LHILH9odWpC.s809W9QMMUtpX9-QxZyebDM93XbL8D6B2qRav-gSsikr3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eQHrh3MszP6taSvdTTp.dSg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:04Z",
        "issued": "2006-02-14T22:19:07Z",
        "valueQuantity": {
          "value": 139,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 50,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 130,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "50 - 130 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eVed6wQtsoO4YHNXMMjadUJHLs2CTKiSoBOim7S9eS1fmW0AlN.7br0l5VebNwjeP3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eVed6wQtsoO4YHNXMMjadUJHLs2CTKiSoBOim7S9eS1fmW0AlN.7br0l5VebNwjeP3",
      "resource": {
        "resourceType": "Observation",
        "id": "eVed6wQtsoO4YHNXMMjadUJHLs2CTKiSoBOim7S9eS1fmW0AlN.7br0l5VebNwjeP3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ehsu6g35pwjBgGNqxj4ptGg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiJlN4Pb62jWsEohoUA0bFA3"
        },
        "effectiveDateTime": "2005-02-14T06:00:00Z",
        "issued": "2005-11-04T17:52:02Z",
        "valueQuantity": {
          "value": 144,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 50,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 130,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "50 - 130 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRn62f2gvJ1SVSpGCpNLdooa6SBtdjV7xcDZEhy-7T8Hvb9m3dIjS.nYpCBO27b9B3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRn62f2gvJ1SVSpGCpNLdooa6SBtdjV7xcDZEhy-7T8Hvb9m3dIjS.nYpCBO27b9B3",
      "resource": {
        "resourceType": "Observation",
        "id": "eRn62f2gvJ1SVSpGCpNLdooa6SBtdjV7xcDZEhy-7T8Hvb9m3dIjS.nYpCBO27b9B3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e8KLPfEVRCShb5ThN1ojPyw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T20:30:00Z",
        "issued": "2005-11-04T17:54:16Z",
        "valueQuantity": {
          "value": 146,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 50,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 130,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "50 - 130 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e4P0cXNVqNCQAEy3O83lHeJxfHanCPvjrHakhHzYS2Wb8YQz87EG3bxGBsZ0AYsbQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e4P0cXNVqNCQAEy3O83lHeJxfHanCPvjrHakhHzYS2Wb8YQz87EG3bxGBsZ0AYsbQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "e4P0cXNVqNCQAEy3O83lHeJxfHanCPvjrHakhHzYS2Wb8YQz87EG3bxGBsZ0AYsbQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eaGrrrRhNipyoS-JW5YCjXQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T23:20:16Z",
        "issued": "2005-10-22T23:20:25Z",
        "valueQuantity": {
          "value": 154,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 50,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 130,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "50 - 130 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ekX0lytcSqyi9C5WuVJhshMxprZ10mdd6zE0r37hoIK2PFIPvxj7yRTK1SrNoTeR23"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ekX0lytcSqyi9C5WuVJhshMxprZ10mdd6zE0r37hoIK2PFIPvxj7yRTK1SrNoTeR23",
      "resource": {
        "resourceType": "Observation",
        "id": "ekX0lytcSqyi9C5WuVJhshMxprZ10mdd6zE0r37hoIK2PFIPvxj7yRTK1SrNoTeR23",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eE5Mv0vyHb8zg3lht3sfI2A3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 153,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "0 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ec112UpEeRdZdwkoaI2f9EJpx9-bOYYsoZmcJ4gBEGuKlziwGLOxPDHUXYbNR3Pox3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ec112UpEeRdZdwkoaI2f9EJpx9-bOYYsoZmcJ4gBEGuKlziwGLOxPDHUXYbNR3Pox3",
      "resource": {
        "resourceType": "Observation",
        "id": "ec112UpEeRdZdwkoaI2f9EJpx9-bOYYsoZmcJ4gBEGuKlziwGLOxPDHUXYbNR3Pox3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eY0VqIHb5La3Z3ojQmQ0d0w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/exiGZVCla2tHmIX5raZ9-rQ3"
        },
        "effectiveDateTime": "1999-10-01T05:00:00Z",
        "valueQuantity": {
          "value": 160,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "0 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edsaYNxj2GuldmyQ-tYdIgxhVNNJyOj-uibuN9PGIbxN.F49VyLhsylx6Cm7pSwQo3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edsaYNxj2GuldmyQ-tYdIgxhVNNJyOj-uibuN9PGIbxN.F49VyLhsylx6Cm7pSwQo3",
      "resource": {
        "resourceType": "Observation",
        "id": "edsaYNxj2GuldmyQ-tYdIgxhVNNJyOj-uibuN9PGIbxN.F49VyLhsylx6Cm7pSwQo3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ehHCQluwCweffaNbykSJUCw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 189,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "0 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ek1bE1ctAYp6espBg9reBh3ltgWuO6p2S087zEpwiLz-ajg.UXDMaEnmuSufEimrp3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ek1bE1ctAYp6espBg9reBh3ltgWuO6p2S087zEpwiLz-ajg.UXDMaEnmuSufEimrp3",
      "resource": {
        "resourceType": "Observation",
        "id": "ek1bE1ctAYp6espBg9reBh3ltgWuO6p2S087zEpwiLz-ajg.UXDMaEnmuSufEimrp3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eBXyRMGLE2miDvhpUU8et6A3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 187,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "0 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e5Vrgx0NtoZVXAmKau.-ju5Jcs1kMrFij6r6WO7hGUqY-BGuxomRWeXiHqHbLbMqi3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e5Vrgx0NtoZVXAmKau.-ju5Jcs1kMrFij6r6WO7hGUqY-BGuxomRWeXiHqHbLbMqi3",
      "resource": {
        "resourceType": "Observation",
        "id": "e5Vrgx0NtoZVXAmKau.-ju5Jcs1kMrFij6r6WO7hGUqY-BGuxomRWeXiHqHbLbMqi3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/es0UW1C-HAnJgqwAg9t1BEQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "LDL Pheresis 1" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 170,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "0 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eOaJiizI8bJcvqXV2vspQzFCzhj7dJ-y4Isjcflr14tyH7Y95ItRVjsMuASmqnjNI3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eOaJiizI8bJcvqXV2vspQzFCzhj7dJ-y4Isjcflr14tyH7Y95ItRVjsMuASmqnjNI3",
      "resource": {
        "resourceType": "Observation",
        "id": "eOaJiizI8bJcvqXV2vspQzFCzhj7dJ-y4Isjcflr14tyH7Y95ItRVjsMuASmqnjNI3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e3idDHUR9DQ0IS9dJL7C3vA3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:29:33Z",
        "valueQuantity": { "value": 3.5, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edFxHUcnp2bRcQBnUrILbLdnibn4vyTvWSiSumuLB21KAZ81H.O8q-u68z-ccFikt3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edFxHUcnp2bRcQBnUrILbLdnibn4vyTvWSiSumuLB21KAZ81H.O8q-u68z-ccFikt3",
      "resource": {
        "resourceType": "Observation",
        "id": "edFxHUcnp2bRcQBnUrILbLdnibn4vyTvWSiSumuLB21KAZ81H.O8q-u68z-ccFikt3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eDRPu3zHKZqnQJl3eWIf9GQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eMPezUGSSxd2I0WMHnke4lA3"
        },
        "effectiveDateTime": "2009-02-22T23:01:00Z",
        "issued": "2009-05-25T22:01:34Z",
        "valueQuantity": { "value": 0.7, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eqm1ut5u4128uIxhogjPA53Ncr5xlolYR18iZFQ1j.TQnq8Cbe4czHmgkzk3wCoCr3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eqm1ut5u4128uIxhogjPA53Ncr5xlolYR18iZFQ1j.TQnq8Cbe4czHmgkzk3wCoCr3",
      "resource": {
        "resourceType": "Observation",
        "id": "eqm1ut5u4128uIxhogjPA53Ncr5xlolYR18iZFQ1j.TQnq8Cbe4czHmgkzk3wCoCr3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/efmm5yZiPXhYno5S5rPyI5g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": { "value": 4.8, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9uBELjURmNEfDKUYRH2vLGefh1RTSBTwgrL42p9XNjzHFTiLkJHIKWC29WN6rqhh3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9uBELjURmNEfDKUYRH2vLGefh1RTSBTwgrL42p9XNjzHFTiLkJHIKWC29WN6rqhh3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9uBELjURmNEfDKUYRH2vLGefh1RTSBTwgrL42p9XNjzHFTiLkJHIKWC29WN6rqhh3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ekM.l6Mf7J2ju1mU2RRT0sA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:15:50Z",
        "issued": "2006-02-14T22:15:53Z",
        "valueQuantity": { "value": 4.2, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e6cb2DcMeZVDt9BeGtmX53B3fi5zUdAPFB3Z7xOxfPlfm8NXb5qjgI8P2OD7.1f4z3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e6cb2DcMeZVDt9BeGtmX53B3fi5zUdAPFB3Z7xOxfPlfm8NXb5qjgI8P2OD7.1f4z3",
      "resource": {
        "resourceType": "Observation",
        "id": "e6cb2DcMeZVDt9BeGtmX53B3fi5zUdAPFB3Z7xOxfPlfm8NXb5qjgI8P2OD7.1f4z3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eDRN7k72mGSlSpzW03rz8Hw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:50Z",
        "valueQuantity": { "value": 4.5, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eD5E9PBhhkogZ5DeujUaRttH7L-wZqQYq8QTvUUyMsgAizuQXRsTnE94PJCvueOuQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eD5E9PBhhkogZ5DeujUaRttH7L-wZqQYq8QTvUUyMsgAizuQXRsTnE94PJCvueOuQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "eD5E9PBhhkogZ5DeujUaRttH7L-wZqQYq8QTvUUyMsgAizuQXRsTnE94PJCvueOuQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e40Q2DHSO8-nVvRAkAxJYaQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2005-03-07T06:30:52Z",
        "valueQuantity": { "value": 4.5, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erN9tgTlj30lj7ck-6ckWtV8RBBU84dUte5lh5cQ0nF1nsDhFyvogf1963r4Ewg-E3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erN9tgTlj30lj7ck-6ckWtV8RBBU84dUte5lh5cQ0nF1nsDhFyvogf1963r4Ewg-E3",
      "resource": {
        "resourceType": "Observation",
        "id": "erN9tgTlj30lj7ck-6ckWtV8RBBU84dUte5lh5cQ0nF1nsDhFyvogf1963r4Ewg-E3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eG2s6sP24NjKuttJq436hYg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": { "value": 4.1, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ezpRl-rRaPkoltq8ouGiJYXa3l905BAdsE2jlmBxBEwarSQ1c4Pga9OaGquD7RxNg3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ezpRl-rRaPkoltq8ouGiJYXa3l905BAdsE2jlmBxBEwarSQ1c4Pga9OaGquD7RxNg3",
      "resource": {
        "resourceType": "Observation",
        "id": "ezpRl-rRaPkoltq8ouGiJYXa3l905BAdsE2jlmBxBEwarSQ1c4Pga9OaGquD7RxNg3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eBlD1Yc1nDnZesOlHm3yphg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": { "value": 4.9, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIy0K-K91AewxXOehYmbUlsqbWyfP-NuC7FVKJBN6YmY25nUAeEGmXywcj7Q0qFUc3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIy0K-K91AewxXOehYmbUlsqbWyfP-NuC7FVKJBN6YmY25nUAeEGmXywcj7Q0qFUc3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIy0K-K91AewxXOehYmbUlsqbWyfP-NuC7FVKJBN6YmY25nUAeEGmXywcj7Q0qFUc3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eRGekH4QMNHv6Fnc3eF5AmQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": { "value": 4.1, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eR1RP88pa6oA-xXhc.QiKlU3kM2W7Vknkj.p3DzAeRHN.Cz3ZfcuawW3mDMcURX0X3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eR1RP88pa6oA-xXhc.QiKlU3kM2W7Vknkj.p3DzAeRHN.Cz3ZfcuawW3mDMcURX0X3",
      "resource": {
        "resourceType": "Observation",
        "id": "eR1RP88pa6oA-xXhc.QiKlU3kM2W7Vknkj.p3DzAeRHN.Cz3ZfcuawW3mDMcURX0X3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ezKIjRv47DhBuAYSLx9zHow3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJS7K8R.VMYRNMPkBgHcslQ3"
        },
        "effectiveDateTime": "1997-05-26T05:00:00Z",
        "valueQuantity": { "value": 3.9, "unit": "mlU/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e569.Og1.WY4JE4Tdm0AVAIRq9NlbUm1DKjpng6..IBy2PQ74ovNkECC8C3ukXDKu3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e569.Og1.WY4JE4Tdm0AVAIRq9NlbUm1DKjpng6..IBy2PQ74ovNkECC8C3ukXDKu3",
      "resource": {
        "resourceType": "Observation",
        "id": "e569.Og1.WY4JE4Tdm0AVAIRq9NlbUm1DKjpng6..IBy2PQ74ovNkECC8C3ukXDKu3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e3CatswHMbPLhXmbItacXZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e82ervAK3Xu6ba-9SyGsUCg3"
        },
        "effectiveDateTime": "1997-02-17T06:00:00Z",
        "valueQuantity": { "value": 8.9, "unit": "mlU/L" },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eeMROyPA8Lxy-ZLHRZEbULeKsIXWNGiLtgnEop0LOMAoDZMvXhQHRJFQHxcP8h.yf3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eeMROyPA8Lxy-ZLHRZEbULeKsIXWNGiLtgnEop0LOMAoDZMvXhQHRJFQHxcP8h.yf3",
      "resource": {
        "resourceType": "Observation",
        "id": "eeMROyPA8Lxy-ZLHRZEbULeKsIXWNGiLtgnEop0LOMAoDZMvXhQHRJFQHxcP8h.yf3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/evpScXUYwxxLaqIC6noGvUQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "TSH, PKU" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": { "value": 12.5, "unit": "mlU/L" },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "mlU/L" },
            "high": { "value": 5, "unit": "mlU/L" },
            "text": "0.3 - 5.0 mlU/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAEZEET8rIRNxW4T6ERwhDeQE.xe5RrqdHYjHyDaokb6r3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAEZEET8rIRNxW4T6ERwhDeQE.xe5RrqdHYjHyDaokb6r3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBScTcqxI2dsc3wbHZ0cZAEZEET8rIRNxW4T6ERwhDeQE.xe5RrqdHYjHyDaokb6r3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEd5aqiFPIVecYrPAEWIUEQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "33037-3",
              "display": "Anion gap in Serum or Plasma"
            }
          ],
          "text": "Anion Gap"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:30:34Z",
        "valueQuantity": {
          "value": 12,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 16,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "8 - 16 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eZ7ItXZuHrGL-1PgTU2axF9-Gvc8WLPtVnIoHhZCn-cxfJLar1ABJuwcIXcrcdopR3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eZ7ItXZuHrGL-1PgTU2axF9-Gvc8WLPtVnIoHhZCn-cxfJLar1ABJuwcIXcrcdopR3",
      "resource": {
        "resourceType": "Observation",
        "id": "eZ7ItXZuHrGL-1PgTU2axF9-Gvc8WLPtVnIoHhZCn-cxfJLar1ABJuwcIXcrcdopR3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eTQPYiOJ6wyAJw4fCBJHGgw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1742-6",
              "display": "Alanine aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "ALT (SGPT)"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev.VmnOEBfLYMRNNTUm3Hdw3"
        },
        "effectiveDateTime": "2010-03-03T14:46:37Z",
        "issued": "2011-03-03T14:47:19Z",
        "valueQuantity": {
          "value": 24,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 25,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "0 - 25 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ejlRvMjKgdJFemzC.56Xy0mTRYZ9iMO0LwULu-Zu6jLQ45Bk4lF4ofMIdhdzSDGNn3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ejlRvMjKgdJFemzC.56Xy0mTRYZ9iMO0LwULu-Zu6jLQ45Bk4lF4ofMIdhdzSDGNn3",
      "resource": {
        "resourceType": "Observation",
        "id": "ejlRvMjKgdJFemzC.56Xy0mTRYZ9iMO0LwULu-Zu6jLQ45Bk4lF4ofMIdhdzSDGNn3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/edUSArGl867oF5fhYSI5iIw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1742-6",
              "display": "Alanine aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "ALT (SGPT)"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eQH4DYpdRZlOBwHKZZVSsqw3"
        },
        "effectiveDateTime": "2007-04-18T02:35:46Z",
        "valueQuantity": {
          "value": 31,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 25,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "0 - 25 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evoZOnT3zYlRAhg49OTSfTPuQ7yUUUvdB7u2idarPmAopwU-M08RfOtcRAXSipMkm3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evoZOnT3zYlRAhg49OTSfTPuQ7yUUUvdB7u2idarPmAopwU-M08RfOtcRAXSipMkm3",
      "resource": {
        "resourceType": "Observation",
        "id": "evoZOnT3zYlRAhg49OTSfTPuQ7yUUUvdB7u2idarPmAopwU-M08RfOtcRAXSipMkm3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eABvEaq5AtpQgMr419YDLsQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1742-6",
              "display": "Alanine aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "ALT (SGPT)"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ems1PlzPh.Gu8ho5hoy-9WQ3"
        },
        "effectiveDateTime": "2005-02-14T06:00:00Z",
        "issued": "2005-11-04T17:52:54Z",
        "valueQuantity": {
          "value": 28,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 35,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "0 - 35 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eWqnknHYgMrmyXm1voqRa9ZSKYX6VLLAn8rq5BCNDTwaIm.oRt5EYHbbFzfks97m03"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eWqnknHYgMrmyXm1voqRa9ZSKYX6VLLAn8rq5BCNDTwaIm.oRt5EYHbbFzfks97m03",
      "resource": {
        "resourceType": "Observation",
        "id": "eWqnknHYgMrmyXm1voqRa9ZSKYX6VLLAn8rq5BCNDTwaIm.oRt5EYHbbFzfks97m03",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eQBLC65quGTvatME0RXhMow3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1742-6",
              "display": "Alanine aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "ALT (SGPT)"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:02Z",
        "valueQuantity": {
          "value": 33,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 35,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "0 - 35 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e2K5RD86L8qEKRtBAn1K5Dx7ooIzLhnIQod6pGTanAWdWhhxi6dUMNnuQYoI1McPn3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e2K5RD86L8qEKRtBAn1K5Dx7ooIzLhnIQod6pGTanAWdWhhxi6dUMNnuQYoI1McPn3",
      "resource": {
        "resourceType": "Observation",
        "id": "e2K5RD86L8qEKRtBAn1K5Dx7ooIzLhnIQod6pGTanAWdWhhxi6dUMNnuQYoI1McPn3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eO5xwC3787q1xlfuNpk3Kew3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1742-6",
              "display": "Alanine aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "ALT (SGPT)"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:19:34Z",
        "valueQuantity": {
          "value": 33,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 35,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "0 - 35 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/epybX0Fy3.c2YFahJlzDcGlh77rxr-SF05HioMy7GUIy9f8HwRN-xo1PHEYIUewLR3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/epybX0Fy3.c2YFahJlzDcGlh77rxr-SF05HioMy7GUIy9f8HwRN-xo1PHEYIUewLR3",
      "resource": {
        "resourceType": "Observation",
        "id": "epybX0Fy3.c2YFahJlzDcGlh77rxr-SF05HioMy7GUIy9f8HwRN-xo1PHEYIUewLR3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eW7jCiVV2Osg19xGmE4yR3w3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1920-8",
              "display": "Aspartate aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "AST"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev.VmnOEBfLYMRNNTUm3Hdw3"
        },
        "effectiveDateTime": "2010-03-03T14:46:38Z",
        "issued": "2011-03-03T14:47:08Z",
        "valueQuantity": {
          "value": 30,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 31,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "0 - 31 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eR.ruekFa8DeewqFZ9eV-398RRsCTLHHiMvVi0BLR25s9Si45m7SH8GUKf82yotYf3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eR.ruekFa8DeewqFZ9eV-398RRsCTLHHiMvVi0BLR25s9Si45m7SH8GUKf82yotYf3",
      "resource": {
        "resourceType": "Observation",
        "id": "eR.ruekFa8DeewqFZ9eV-398RRsCTLHHiMvVi0BLR25s9Si45m7SH8GUKf82yotYf3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eA54pOvqZAauEGYSU8r-rhQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1920-8",
              "display": "Aspartate aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "AST"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eQH4DYpdRZlOBwHKZZVSsqw3"
        },
        "effectiveDateTime": "2007-04-18T02:35:46Z",
        "valueQuantity": {
          "value": 20,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 31,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "0 - 31 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eWW6QdpuqOMl1STcRia-gFF6Pks6oVizVvcKJRHj2SXN8LFas5tpSwCvVh.GVf.lc3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eWW6QdpuqOMl1STcRia-gFF6Pks6oVizVvcKJRHj2SXN8LFas5tpSwCvVh.GVf.lc3",
      "resource": {
        "resourceType": "Observation",
        "id": "eWW6QdpuqOMl1STcRia-gFF6Pks6oVizVvcKJRHj2SXN8LFas5tpSwCvVh.GVf.lc3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ehq.gSxZ9CguF7y.ToNv7.g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1920-8",
              "display": "Aspartate aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "AST"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ems1PlzPh.Gu8ho5hoy-9WQ3"
        },
        "effectiveDateTime": "2005-02-14T06:00:00Z",
        "issued": "2005-11-04T17:54:02Z",
        "valueQuantity": {
          "value": 18,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 20,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "0 - 20 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ez1WfmmSlnc8e3SPieT5UBXsU016.saZySJJr4r.BpZWMY46fj8grzB7Y8UHCazZJ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ez1WfmmSlnc8e3SPieT5UBXsU016.saZySJJr4r.BpZWMY46fj8grzB7Y8UHCazZJ3",
      "resource": {
        "resourceType": "Observation",
        "id": "ez1WfmmSlnc8e3SPieT5UBXsU016.saZySJJr4r.BpZWMY46fj8grzB7Y8UHCazZJ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ew3ntZMV-fCplDDGm7tuAYw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1920-8",
              "display": "Aspartate aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "AST"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:52Z",
        "valueQuantity": {
          "value": 38,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 7,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 40,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "7 - 40 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/esRdcFTzJTOHn8FKMnQk6aRWS.fm6BBTQ0UxEsijOT1stYyiqKKr2bgg5a8syZvyi3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/esRdcFTzJTOHn8FKMnQk6aRWS.fm6BBTQ0UxEsijOT1stYyiqKKr2bgg5a8syZvyi3",
      "resource": {
        "resourceType": "Observation",
        "id": "esRdcFTzJTOHn8FKMnQk6aRWS.fm6BBTQ0UxEsijOT1stYyiqKKr2bgg5a8syZvyi3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/erH8WoVW3YueMeudkDiWnRg3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1920-8",
              "display": "Aspartate aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "AST"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2005-03-07T06:30:54Z",
        "valueQuantity": {
          "value": 35,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 35,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "0 - 35 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eWIQ51MlsoPPStgcwZx7DIyH9ejXiMFbypB-oU-8n1TSlgwFVLMtDI8S5l4Uivjiv3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eWIQ51MlsoPPStgcwZx7DIyH9ejXiMFbypB-oU-8n1TSlgwFVLMtDI8S5l4Uivjiv3",
      "resource": {
        "resourceType": "Observation",
        "id": "eWIQ51MlsoPPStgcwZx7DIyH9ejXiMFbypB-oU-8n1TSlgwFVLMtDI8S5l4Uivjiv3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eO2DdmQbdBATIBLyTusEk8g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1920-8",
              "display": "Aspartate aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "AST"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/exiGZVCla2tHmIX5raZ9-rQ3"
        },
        "effectiveDateTime": "1999-10-01T05:00:00Z",
        "valueQuantity": {
          "value": 35,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 10,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 40,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "10 - 40 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eixZ3Kyg0.skCevVSyUWsUtSHq4gGqBUNaj6tT7QafHleaePChg621pL4RhDrnI7X3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eixZ3Kyg0.skCevVSyUWsUtSHq4gGqBUNaj6tT7QafHleaePChg621pL4RhDrnI7X3",
      "resource": {
        "resourceType": "Observation",
        "id": "eixZ3Kyg0.skCevVSyUWsUtSHq4gGqBUNaj6tT7QafHleaePChg621pL4RhDrnI7X3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/elV79WA9P1Lt6Nqn5faayDQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1920-8",
              "display": "Aspartate aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "AST"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 35,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 10,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 40,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "10 - 40 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e3pzTeugBQiH7w13nWaZ.Mthm93HZjPTpjSztZIF.gCVvE5CZtUVQ3PhnEiLyZcb23"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e3pzTeugBQiH7w13nWaZ.Mthm93HZjPTpjSztZIF.gCVvE5CZtUVQ3PhnEiLyZcb23",
      "resource": {
        "resourceType": "Observation",
        "id": "e3pzTeugBQiH7w13nWaZ.Mthm93HZjPTpjSztZIF.gCVvE5CZtUVQ3PhnEiLyZcb23",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/esfy7LkI97CcS2w5iysAYXw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "1920-8",
              "display": "Aspartate aminotransferase [Enzymatic activity/volume] in Serum or Plasma"
            }
          ],
          "text": "AST"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 39,
          "unit": "U/L",
          "system": "http://unitsofmeasure.org",
          "code": "U/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 10,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "high": {
              "value": 40,
              "unit": "U/L",
              "system": "http://unitsofmeasure.org",
              "code": "U/L"
            },
            "text": "10 - 40 U/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAEZEET8rIRNxW4T6ERwhDeSSktkEYMMyxj0pHgjRXnoP3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAEZEET8rIRNxW4T6ERwhDeSSktkEYMMyxj0pHgjRXnoP3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBScTcqxI2dsc3wbHZ0cZAEZEET8rIRNxW4T6ERwhDeSSktkEYMMyxj0pHgjRXnoP3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEd5aqiFPIVecYrPAEWIUEQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "3094-0",
              "display": "Urea nitrogen [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "BUN"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:30:34Z",
        "valueQuantity": {
          "value": 10,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 5,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 20,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "5 - 20 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AabowMXuFZF9VPm4hdHKuaydGv3ws-U.tSqB-NbCWCaKV3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AabowMXuFZF9VPm4hdHKuaydGv3ws-U.tSqB-NbCWCaKV3",
      "resource": {
        "resourceType": "Observation",
        "id": "ePdjCrNz2KcTr2Rnae.4AabowMXuFZF9VPm4hdHKuaydGv3ws-U.tSqB-NbCWCaKV3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eB5nqBicqmsZeCHplNzhy7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "3094-0",
              "display": "Urea nitrogen [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "BUN"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 17,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 5,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 20,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "5 - 20 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRGNxf0eS9D.fwOZCWrSelSzchnTc4a8GivSwuW36YRNw3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRGNxf0eS9D.fwOZCWrSelSzchnTc4a8GivSwuW36YRNw3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIiwhgwmsW8Ousqj-LmfKRGNxf0eS9D.fwOZCWrSelSzchnTc4a8GivSwuW36YRNw3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEEmMzRjlFj4tpgcdygAM7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "3094-0",
              "display": "Urea nitrogen [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "BUN"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:38Z",
        "issued": "2006-02-14T22:19:40Z",
        "valueQuantity": {
          "value": 18,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 5,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 20,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "5 - 20 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCOfWoCaFP0uDelXfaIoWZNQbTjFi60hjIfBu474zs24S3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCOfWoCaFP0uDelXfaIoWZNQbTjFi60hjIfBu474zs24S3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCOfWoCaFP0uDelXfaIoWZNQbTjFi60hjIfBu474zs24S3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Eosinophils, CSF" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": { "value": 0.3, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.05, "unit": "X 10E9/L" },
            "high": { "value": 0.5, "unit": "X 10E9/L" },
            "text": "0.05 - 0.50 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyfVbshsInk40b6.EAgdIsqxAoUUqyAmv1qm-.JEA5R2p3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyfVbshsInk40b6.EAgdIsqxAoUUqyAmv1qm-.JEA5R2p3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyfVbshsInk40b6.EAgdIsqxAoUUqyAmv1qm-.JEA5R2p3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Eosinophils, CSF" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": { "value": 0.3, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.05, "unit": "X 10E9/L" },
            "high": { "value": 0.5, "unit": "X 10E9/L" },
            "text": "0.05 - 0.50 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SezDnOgOoXxdcnJpG0U2zctjv1-faDVOZEYpfX5raCr23"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SezDnOgOoXxdcnJpG0U2zctjv1-faDVOZEYpfX5raCr23",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SezDnOgOoXxdcnJpG0U2zctjv1-faDVOZEYpfX5raCr23",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Eosinophils, CSF" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": { "value": 0.3, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.05, "unit": "X 10E9/L" },
            "high": { "value": 0.5, "unit": "X 10E9/L" },
            "text": "0.05 - 0.50 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarxwwT67LxzGYuKCfaQEQqhxEF08nCaystwJNcvspwK30P3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarxwwT67LxzGYuKCfaQEQqhxEF08nCaystwJNcvspwK30P3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarxwwT67LxzGYuKCfaQEQqhxEF08nCaystwJNcvspwK30P3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Eosinophils, CSF" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": { "value": 0.3, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.05, "unit": "X 10E9/L" },
            "high": { "value": 0.5, "unit": "X 10E9/L" },
            "text": "0.05 - 0.50 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wgfcLdVNiWBmy2.bbyepL7LOWPkdNSZ-eJB.NcGThTtp3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wgfcLdVNiWBmy2.bbyepL7LOWPkdNSZ-eJB.NcGThTtp3",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1wgfcLdVNiWBmy2.bbyepL7LOWPkdNSZ-eJB.NcGThTtp3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Eosinophils, CSF" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": { "value": 0.2, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.05, "unit": "X 10E9/L" },
            "high": { "value": 0.5, "unit": "X 10E9/L" },
            "text": "0.05 - 0.50 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VmynKG--gwQcwCEXPH1dpX5Xhk-UsXQ.JPNx-a501Ln53"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VmynKG--gwQcwCEXPH1dpX5Xhk-UsXQ.JPNx-a501Ln53",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9VmynKG--gwQcwCEXPH1dpX5Xhk-UsXQ.JPNx-a501Ln53",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Eosinophils, CSF" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": { "value": 0.1, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.05, "unit": "X 10E9/L" },
            "high": { "value": 0.5, "unit": "X 10E9/L" },
            "text": "0.05 - 0.50 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ezssXRBIVJXbvFjD5xlNTCjNLqNP-N6MBVfv8F5Uj.Asrol-q0thyfDd.XAUCI8X43"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ezssXRBIVJXbvFjD5xlNTCjNLqNP-N6MBVfv8F5Uj.Asrol-q0thyfDd.XAUCI8X43",
      "resource": {
        "resourceType": "Observation",
        "id": "ezssXRBIVJXbvFjD5xlNTCjNLqNP-N6MBVfv8F5Uj.Asrol-q0thyfDd.XAUCI8X43",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ec8rMVv0dI6Pm5UwnStL2-Q3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2276-4",
              "display": "Ferritin [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Ferritin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:59Z",
        "valueQuantity": {
          "value": 96,
          "unit": "ng/ml",
          "system": "http://unitsofmeasure.org",
          "code": "ng/ml"
        },
        "referenceRange": [
          {
            "low": {
              "value": 12,
              "unit": "ng/ml",
              "system": "http://unitsofmeasure.org",
              "code": "ng/ml"
            },
            "high": {
              "value": 150,
              "unit": "ng/ml",
              "system": "http://unitsofmeasure.org",
              "code": "ng/ml"
            },
            "text": "12.0 - 150.0 ng/ml"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ef0NIOh6W-EwnxO3hhBwJI9JtXEmP9HmWKWZ4ik-HFSSk9KUZV1fl9JWyVPVCfKvh3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ef0NIOh6W-EwnxO3hhBwJI9JtXEmP9HmWKWZ4ik-HFSSk9KUZV1fl9JWyVPVCfKvh3",
      "resource": {
        "resourceType": "Observation",
        "id": "ef0NIOh6W-EwnxO3hhBwJI9JtXEmP9HmWKWZ4ik-HFSSk9KUZV1fl9JWyVPVCfKvh3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLHFALqjX9CuVpf-aw5-gKw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2276-4",
              "display": "Ferritin [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Ferritin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:55Z",
        "valueQuantity": {
          "value": 96,
          "unit": "ng/ml",
          "system": "http://unitsofmeasure.org",
          "code": "ng/ml"
        },
        "referenceRange": [
          {
            "low": {
              "value": 15,
              "unit": "ng/ml",
              "system": "http://unitsofmeasure.org",
              "code": "ng/ml"
            },
            "high": {
              "value": 300,
              "unit": "ng/ml",
              "system": "http://unitsofmeasure.org",
              "code": "ng/ml"
            },
            "text": "15.0 - 300.0 ng/ml"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.es3RhqbGRARaVSbU3ixZ-2m2RPwwIJ8GJHFCtA7ZTnJH3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.es3RhqbGRARaVSbU3ixZ-2m2RPwwIJ8GJHFCtA7ZTnJH3",
      "resource": {
        "resourceType": "Observation",
        "id": "exbDjZSimhyOZeXAwFnu.es3RhqbGRARaVSbU3ixZ-2m2RPwwIJ8GJHFCtA7ZTnJH3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewLQH0YsPQVhbqmPzD7132g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:20:21Z",
        "issued": "2006-02-14T22:20:25Z",
        "valueString": "Negative"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eqNvgACf8nZ3QzmtbEhIfV9m8dUFRZmQLeuJn.Px6FZj3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eqNvgACf8nZ3QzmtbEhIfV9m8dUFRZmQLeuJn.Px6FZj3",
      "resource": {
        "resourceType": "Observation",
        "id": "exbDjZSimhyOZeXAwFnu.eqNvgACf8nZ3QzmtbEhIfV9m8dUFRZmQLeuJn.Px6FZj3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewLQH0YsPQVhbqmPzD7132g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2887-8",
              "display": "Protein [Presence] in Urine"
            }
          ],
          "text": "Protein, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:20:21Z",
        "issued": "2006-02-14T22:20:25Z",
        "valueQuantity": { "value": 52, "unit": "mg/24hrs" },
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "mg/24hrs" },
            "high": { "value": 93, "unit": "mg/24hrs" },
            "text": "0 - 93 mg/24hrs"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZrhw8PwEF74jt6K-y.xcWtyotfrJtzym-QMB73lc7Ims3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZrhw8PwEF74jt6K-y.xcWtyotfrJtzym-QMB73lc7Ims3",
      "resource": {
        "resourceType": "Observation",
        "id": "eka69uezXMNh7wr6.0TAIZrhw8PwEF74jt6K-y.xcWtyotfrJtzym-QMB73lc7Ims3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLZaRNUq0g3pncFPb.XmOHw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2887-8",
              "display": "Protein [Presence] in Urine"
            }
          ],
          "text": "Protein, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:06Z",
        "valueQuantity": { "value": 0, "unit": "mg/24hrs" },
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "mg/24hrs" },
            "high": { "value": 93, "unit": "mg/24hrs" },
            "text": "0 - 93 mg/24hrs"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nc20ivyVtziAlkeGArIWReb1sY5D.I7z6FxjxZo1jC7Q3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nc20ivyVtziAlkeGArIWReb1sY5D.I7z6FxjxZo1jC7Q3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIbH1jowqqHQNfVhgGc79nc20ivyVtziAlkeGArIWReb1sY5D.I7z6FxjxZo1jC7Q3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ecbsxsqbqEUYGoCYdZdXMpw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2887-8",
              "display": "Protein [Presence] in Urine"
            }
          ],
          "text": "Protein, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:20:20Z",
        "valueQuantity": { "value": 0, "unit": "mg/24hrs" },
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "mg/24hrs" },
            "high": { "value": 150, "unit": "mg/24hrs" },
            "text": "0 - 150 mg/24hrs"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKed9p5Im3U7uUUDDqtMQxY5e5g0OOpPqBdc1K-kmMvOrm3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKed9p5Im3U7uUUDDqtMQxY5e5g0OOpPqBdc1K-kmMvOrm3",
      "resource": {
        "resourceType": "Observation",
        "id": "e7x8ub3aGUMdcjK8ybIIKed9p5Im3U7uUUDDqtMQxY5e5g0OOpPqBdc1K-kmMvOrm3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eC-44wGlTKQjwvsYWff57ZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2887-8",
              "display": "Protein [Presence] in Urine"
            }
          ],
          "text": "Protein, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "Neg",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "mg/24hrs" },
            "high": { "value": 150, "unit": "mg/24hrs" },
            "text": "0 - 150 mg/24hrs"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0SqkrhJELoKYhro24weHO.h.VTHWnZXF4uSkLFIGJFGEA7vK3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0SqkrhJELoKYhro24weHO.h.VTHWnZXF4uSkLFIGJFGEA7vK3",
      "resource": {
        "resourceType": "Observation",
        "id": "eUqbXu0xjNYxyJk6O0SqkrhJELoKYhro24weHO.h.VTHWnZXF4uSkLFIGJFGEA7vK3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eVcTtimjYsPMqIcppXAeaUw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2887-8",
              "display": "Protein [Presence] in Urine"
            }
          ],
          "text": "Protein, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "Neg",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "mg/24hrs" },
            "high": { "value": 150, "unit": "mg/24hrs" },
            "text": "0 - 150 mg/24hrs"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAPjAlkF1qkoMLV5ssmmxmL4uxHVXiPgko0eCf7a5jfLh3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAPjAlkF1qkoMLV5ssmmxmL4uxHVXiPgko0eCf7a5jfLh3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBScTcqxI2dsc3wbHZ0cZAPjAlkF1qkoMLV5ssmmxmL4uxHVXiPgko0eCf7a5jfLh3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEd5aqiFPIVecYrPAEWIUEQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:30:34Z",
        "valueQuantity": {
          "value": 4.3,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AaTGc.wjohAOn.Pc4cMGqtNt-WOt17QlK0EKu8MrMHZXX3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AaTGc.wjohAOn.Pc4cMGqtNt-WOt17QlK0EKu8MrMHZXX3",
      "resource": {
        "resourceType": "Observation",
        "id": "ePdjCrNz2KcTr2Rnae.4AaTGc.wjohAOn.Pc4cMGqtNt-WOt17QlK0EKu8MrMHZXX3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eB5nqBicqmsZeCHplNzhy7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 3.9,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRFQua67T085uThU7F3SLKnnyc5385EzNM9t1l4EIgEZL3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRFQua67T085uThU7F3SLKnnyc5385EzNM9t1l4EIgEZL3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIiwhgwmsW8Ousqj-LmfKRFQua67T085uThU7F3SLKnnyc5385EzNM9t1l4EIgEZL3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEEmMzRjlFj4tpgcdygAM7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:38Z",
        "issued": "2006-02-14T22:19:40Z",
        "valueQuantity": {
          "value": 3.8,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuQp.mCD8-T96ftlJ.uP6zU2jBhTDtOuYJYgOyI1japD13"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuQp.mCD8-T96ftlJ.uP6zU2jBhTDtOuYJYgOyI1japD13",
      "resource": {
        "resourceType": "Observation",
        "id": "eRoR7q5P-NRZBKPzyLwgnuQp.mCD8-T96ftlJ.uP6zU2jBhTDtOuYJYgOyI1japD13",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4OetgbmmyJUdElq5nV0Kig3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:01Z",
        "valueQuantity": {
          "value": 4.1,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vhVyFLPo7f-lKcJA5DOWAUhjLiLhyn4wlvsZ1Jb3.k2f3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vhVyFLPo7f-lKcJA5DOWAUhjLiLhyn4wlvsZ1Jb3.k2f3",
      "resource": {
        "resourceType": "Observation",
        "id": "eKHAY5Bp-e0ZN3-OmG481vhVyFLPo7f-lKcJA5DOWAUhjLiLhyn4wlvsZ1Jb3.k2f3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ezQ7IMnsWQ4LX6RkQDYtxZA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:19:20Z",
        "valueQuantity": {
          "value": 4.1,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSOwG.MvZ2.kktkCkHWoQUuI0vC2WA13uSECJa.H8toMmR3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSOwG.MvZ2.kktkCkHWoQUuI0vC2WA13uSECJa.H8toMmR3",
      "resource": {
        "resourceType": "Observation",
        "id": "eG9LkyxbHz4pLMCembiWSOwG.MvZ2.kktkCkHWoQUuI0vC2WA13uSECJa.H8toMmR3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e1DmTHSh6fjZHl.iwL1UvwQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 4.0,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x1n96N-aySDN8ZgfAWq85cikkBcLZa-8xJ5lx4541SPs3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x1n96N-aySDN8ZgfAWq85cikkBcLZa-8xJ5lx4541SPs3",
      "resource": {
        "resourceType": "Observation",
        "id": "erhmvJ47wMUAuUoiBSls8x1n96N-aySDN8ZgfAWq85cikkBcLZa-8xJ5lx4541SPs3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e7PspqInomYypkaM6thGHiA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 4.1,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux-PUK8VjGXkbjAhluA.Uq2VaK8GKn2EtgCNAwHwiXd9m3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux-PUK8VjGXkbjAhluA.Uq2VaK8GKn2EtgCNAwHwiXd9m3",
      "resource": {
        "resourceType": "Observation",
        "id": "eujnQ5OQreTwjBUPo9Cvux-PUK8VjGXkbjAhluA.Uq2VaK8GKn2EtgCNAwHwiXd9m3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eO1Q18BbDJFpjPnNwgTTfOw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 3.9,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z7RDGc-cU0VZI71GL8F0Xa0M.ldP6c30bfOU4EZASmV23"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z7RDGc-cU0VZI71GL8F0Xa0M.ldP6c30bfOU4EZASmV23",
      "resource": {
        "resourceType": "Observation",
        "id": "ereKB7Ir7tvrPVLzvQHf1Z7RDGc-cU0VZI71GL8F0Xa0M.ldP6c30bfOU4EZASmV23",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e6QUFcWf-6SF2tLYg7dJ.Fg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e82ervAK3Xu6ba-9SyGsUCg3"
        },
        "effectiveDateTime": "1997-02-17T06:00:00Z",
        "valueQuantity": {
          "value": 3.8,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkC-RekiNOlaPYWfQchx0a1metXeU2pMfdnlqxCNuYzrsO3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkC-RekiNOlaPYWfQchx0a1metXeU2pMfdnlqxCNuYzrsO3",
      "resource": {
        "resourceType": "Observation",
        "id": "evZrMLoPaxzj4iA7-VWIkC-RekiNOlaPYWfQchx0a1metXeU2pMfdnlqxCNuYzrsO3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ec.w5K7Nw-5HefdYFkkG2WQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2823-3",
              "display": "Potassium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Potassium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 3.5,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": {
              "value": 3.6,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 4.8,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "3.6 - 4.8 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAPjAlkF1qkoMLV5ssmmxmL5gi-W8LjNe5NlEmlLcQwpa3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAPjAlkF1qkoMLV5ssmmxmL5gi-W8LjNe5NlEmlLcQwpa3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBScTcqxI2dsc3wbHZ0cZAPjAlkF1qkoMLV5ssmmxmL5gi-W8LjNe5NlEmlLcQwpa3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEd5aqiFPIVecYrPAEWIUEQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:30:34Z",
        "valueQuantity": {
          "value": 137,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AaTGc.wjohAOn.Pc4cMGqtNuYaZCgsoWZnMyz.FJ-gI3M3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AaTGc.wjohAOn.Pc4cMGqtNuYaZCgsoWZnMyz.FJ-gI3M3",
      "resource": {
        "resourceType": "Observation",
        "id": "ePdjCrNz2KcTr2Rnae.4AaTGc.wjohAOn.Pc4cMGqtNuYaZCgsoWZnMyz.FJ-gI3M3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eB5nqBicqmsZeCHplNzhy7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 143,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRFQua67T085uThU7F3SLKnlVMr2HxBuqC4ueJGVRJ6t63"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRFQua67T085uThU7F3SLKnlVMr2HxBuqC4ueJGVRJ6t63",
      "resource": {
        "resourceType": "Observation",
        "id": "eIiwhgwmsW8Ousqj-LmfKRFQua67T085uThU7F3SLKnlVMr2HxBuqC4ueJGVRJ6t63",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEEmMzRjlFj4tpgcdygAM7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:38Z",
        "issued": "2006-02-14T22:19:40Z",
        "valueQuantity": {
          "value": 139,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuQp.mCD8-T96ftlJ.uP6zU0VMTWbPcE0G093SLErbbc63"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuQp.mCD8-T96ftlJ.uP6zU0VMTWbPcE0G093SLErbbc63",
      "resource": {
        "resourceType": "Observation",
        "id": "eRoR7q5P-NRZBKPzyLwgnuQp.mCD8-T96ftlJ.uP6zU0VMTWbPcE0G093SLErbbc63",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4OetgbmmyJUdElq5nV0Kig3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:01Z",
        "valueQuantity": {
          "value": 141,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vhVyFLPo7f-lKcJA5DOWAUiKJ-1-1V8kpyBdfEBF9AWq3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vhVyFLPo7f-lKcJA5DOWAUiKJ-1-1V8kpyBdfEBF9AWq3",
      "resource": {
        "resourceType": "Observation",
        "id": "eKHAY5Bp-e0ZN3-OmG481vhVyFLPo7f-lKcJA5DOWAUiKJ-1-1V8kpyBdfEBF9AWq3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ezQ7IMnsWQ4LX6RkQDYtxZA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:19:20Z",
        "valueQuantity": {
          "value": 141,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSOwG.MvZ2.kktkCkHWoQUuI2PAq.dlBn3O8BW9Wcs6qKY3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSOwG.MvZ2.kktkCkHWoQUuI2PAq.dlBn3O8BW9Wcs6qKY3",
      "resource": {
        "resourceType": "Observation",
        "id": "eG9LkyxbHz4pLMCembiWSOwG.MvZ2.kktkCkHWoQUuI2PAq.dlBn3O8BW9Wcs6qKY3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e1DmTHSh6fjZHl.iwL1UvwQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 140,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x1n96N-aySDN8ZgfAWq85cg0JjipFxIc14PGBg8jkUcw3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x1n96N-aySDN8ZgfAWq85cg0JjipFxIc14PGBg8jkUcw3",
      "resource": {
        "resourceType": "Observation",
        "id": "erhmvJ47wMUAuUoiBSls8x1n96N-aySDN8ZgfAWq85cg0JjipFxIc14PGBg8jkUcw3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e7PspqInomYypkaM6thGHiA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 141,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux-PUK8VjGXkbjAhluA.Uq2U2A61YLnL44sVWNQDbOhCy3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux-PUK8VjGXkbjAhluA.Uq2U2A61YLnL44sVWNQDbOhCy3",
      "resource": {
        "resourceType": "Observation",
        "id": "eujnQ5OQreTwjBUPo9Cvux-PUK8VjGXkbjAhluA.Uq2U2A61YLnL44sVWNQDbOhCy3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eO1Q18BbDJFpjPnNwgTTfOw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 141,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z7RDGc-cU0VZI71GL8F0Xa1We1WbvQTWVe1ZuFb2yNdM3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z7RDGc-cU0VZI71GL8F0Xa1We1WbvQTWVe1ZuFb2yNdM3",
      "resource": {
        "resourceType": "Observation",
        "id": "ereKB7Ir7tvrPVLzvQHf1Z7RDGc-cU0VZI71GL8F0Xa1We1WbvQTWVe1ZuFb2yNdM3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e6QUFcWf-6SF2tLYg7dJ.Fg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e82ervAK3Xu6ba-9SyGsUCg3"
        },
        "effectiveDateTime": "1997-02-17T06:00:00Z",
        "valueQuantity": {
          "value": 141,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkC-RekiNOlaPYWfQchx0a1mfXVBcANae29wPpGZuVqJ4M3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkC-RekiNOlaPYWfQchx0a1mfXVBcANae29wPpGZuVqJ4M3",
      "resource": {
        "resourceType": "Observation",
        "id": "evZrMLoPaxzj4iA7-VWIkC-RekiNOlaPYWfQchx0a1mfXVBcANae29wPpGZuVqJ4M3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ec.w5K7Nw-5HefdYFkkG2WQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2951-2",
              "display": "Sodium [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Sodium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 136,
          "unit": "mEq/L",
          "system": "http://unitsofmeasure.org",
          "code": "mEq/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 135,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "high": {
              "value": 145,
              "unit": "mEq/L",
              "system": "http://unitsofmeasure.org",
              "code": "mEq/L"
            },
            "text": "135 - 145 mEq/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAPjAlkF1qkoMLV5ssmmxmL7FkjM-OUXu0mt8gG3UcO0A3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBScTcqxI2dsc3wbHZ0cZAPjAlkF1qkoMLV5ssmmxmL7FkjM-OUXu0mt8gG3UcO0A3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBScTcqxI2dsc3wbHZ0cZAPjAlkF1qkoMLV5ssmmxmL7FkjM-OUXu0mt8gG3UcO0A3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEd5aqiFPIVecYrPAEWIUEQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:30:34Z",
        "valueQuantity": {
          "value": 102,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AaTGc.wjohAOn.Pc4cMGqtNtzrsxU-J1yzWMfCZMqLiQQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4AaTGc.wjohAOn.Pc4cMGqtNtzrsxU-J1yzWMfCZMqLiQQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "ePdjCrNz2KcTr2Rnae.4AaTGc.wjohAOn.Pc4cMGqtNtzrsxU-J1yzWMfCZMqLiQQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eB5nqBicqmsZeCHplNzhy7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 101,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRFQua67T085uThU7F3SLKnlPp8Gkmg3xifThDtkqecS-3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRFQua67T085uThU7F3SLKnlPp8Gkmg3xifThDtkqecS-3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIiwhgwmsW8Ousqj-LmfKRFQua67T085uThU7F3SLKnlPp8Gkmg3xifThDtkqecS-3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEEmMzRjlFj4tpgcdygAM7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:38Z",
        "issued": "2006-02-14T22:19:40Z",
        "valueQuantity": {
          "value": 103,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuQp.mCD8-T96ftlJ.uP6zU3.5OUHQakzcAmSTcpVKBf13"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuQp.mCD8-T96ftlJ.uP6zU3.5OUHQakzcAmSTcpVKBf13",
      "resource": {
        "resourceType": "Observation",
        "id": "eRoR7q5P-NRZBKPzyLwgnuQp.mCD8-T96ftlJ.uP6zU3.5OUHQakzcAmSTcpVKBf13",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4OetgbmmyJUdElq5nV0Kig3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:01Z",
        "valueQuantity": {
          "value": 102,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vhVyFLPo7f-lKcJA5DOWAUgugQPauKADFOowz.6QXV3M3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vhVyFLPo7f-lKcJA5DOWAUgugQPauKADFOowz.6QXV3M3",
      "resource": {
        "resourceType": "Observation",
        "id": "eKHAY5Bp-e0ZN3-OmG481vhVyFLPo7f-lKcJA5DOWAUgugQPauKADFOowz.6QXV3M3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ezQ7IMnsWQ4LX6RkQDYtxZA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:19:20Z",
        "valueQuantity": {
          "value": 102,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSOwG.MvZ2.kktkCkHWoQUuI1oMIwgbIJM3.6ii.h0xTqN3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSOwG.MvZ2.kktkCkHWoQUuI1oMIwgbIJM3.6ii.h0xTqN3",
      "resource": {
        "resourceType": "Observation",
        "id": "eG9LkyxbHz4pLMCembiWSOwG.MvZ2.kktkCkHWoQUuI1oMIwgbIJM3.6ii.h0xTqN3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e1DmTHSh6fjZHl.iwL1UvwQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 101,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x1n96N-aySDN8ZgfAWq85cimNOCdVdXWxww7mZW9ZdtN3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x1n96N-aySDN8ZgfAWq85cimNOCdVdXWxww7mZW9ZdtN3",
      "resource": {
        "resourceType": "Observation",
        "id": "erhmvJ47wMUAuUoiBSls8x1n96N-aySDN8ZgfAWq85cimNOCdVdXWxww7mZW9ZdtN3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e7PspqInomYypkaM6thGHiA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 101,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux-PUK8VjGXkbjAhluA.Uq2U73Tb3pfg0VVvcAa7-gZZ53"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux-PUK8VjGXkbjAhluA.Uq2U73Tb3pfg0VVvcAa7-gZZ53",
      "resource": {
        "resourceType": "Observation",
        "id": "eujnQ5OQreTwjBUPo9Cvux-PUK8VjGXkbjAhluA.Uq2U73Tb3pfg0VVvcAa7-gZZ53",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eO1Q18BbDJFpjPnNwgTTfOw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 100,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z7RDGc-cU0VZI71GL8F0Xa0ZuvZo.nxwOzzSGADsc1SS3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z7RDGc-cU0VZI71GL8F0Xa0ZuvZo.nxwOzzSGADsc1SS3",
      "resource": {
        "resourceType": "Observation",
        "id": "ereKB7Ir7tvrPVLzvQHf1Z7RDGc-cU0VZI71GL8F0Xa0ZuvZo.nxwOzzSGADsc1SS3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e6QUFcWf-6SF2tLYg7dJ.Fg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e82ervAK3Xu6ba-9SyGsUCg3"
        },
        "effectiveDateTime": "1997-02-17T06:00:00Z",
        "valueQuantity": {
          "value": 102,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkC-RekiNOlaPYWfQchx0a1mem0yMWTLiX3Bz8UQB5oAhQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkC-RekiNOlaPYWfQchx0a1mem0yMWTLiX3Bz8UQB5oAhQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "evZrMLoPaxzj4iA7-VWIkC-RekiNOlaPYWfQchx0a1mem0yMWTLiX3Bz8UQB5oAhQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ec.w5K7Nw-5HefdYFkkG2WQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2075-0",
              "display": "Chloride [Moles/volume] in Serum or Plasma"
            }
          ],
          "text": "Chloride"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 101,
          "unit": "mmol/L",
          "system": "http://unitsofmeasure.org",
          "code": "mmol/L"
        },
        "referenceRange": [
          {
            "low": {
              "value": 98,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "high": {
              "value": 106,
              "unit": "mmol/L",
              "system": "http://unitsofmeasure.org",
              "code": "mmol/L"
            },
            "text": "98 - 106 mmol/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCD9Vdli8cXLYjtX0t3MEhrPbf.G09dyIYFBAx20odMZC3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCD9Vdli8cXLYjtX0t3MEhrPbf.G09dyIYFBAx20odMZC3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCD9Vdli8cXLYjtX0t3MEhrPbf.G09dyIYFBAx20odMZC3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": {
          "value": 39.8,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 34.9,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 44.5,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "34 - 44 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.Eydmj8jMCSwJmkXv7N5IFoRV3Ht24AIE39jBD7pkt4sbY3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.Eydmj8jMCSwJmkXv7N5IFoRV3Ht24AIE39jBD7pkt4sbY3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.Eydmj8jMCSwJmkXv7N5IFoRV3Ht24AIE39jBD7pkt4sbY3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": {
          "value": 43.9,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8ScWX6lrNK6mjgdJVGquv5ge3EFjfnrXCH8M5RXO1ThXR3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8ScWX6lrNK6mjgdJVGquv5ge3EFjfnrXCH8M5RXO1ThXR3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8ScWX6lrNK6mjgdJVGquv5ge3EFjfnrXCH8M5RXO1ThXR3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 44.4,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx.s2MiMAvVT7bSBONZiLSYKLHNZLuykj2liAjO.J0AzM3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx.s2MiMAvVT7bSBONZiLSYKLHNZLuykj2liAjO.J0AzM3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarx.s2MiMAvVT7bSBONZiLSYKLHNZLuykj2liAjO.J0AzM3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 40.9,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wpuF3eOATjeS8AekZlGRgOpa4BfoEtda28QxNl1-j0hg3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wpuF3eOATjeS8AekZlGRgOpa4BfoEtda28QxNl1-j0hg3",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1wpuF3eOATjeS8AekZlGRgOpa4BfoEtda28QxNl1-j0hg3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 42.9,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VpMBV3ZY99aOeYzCYo0nPp2KThRakzBTqgILrajuG.Nn3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VpMBV3ZY99aOeYzCYo0nPp2KThRakzBTqgILrajuG.Nn3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9VpMBV3ZY99aOeYzCYo0nPp2KThRakzBTqgILrajuG.Nn3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 42.9,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eqNvgACf8nZ3QzmtbEhIfV8KtItb492O.UqlvUtEMQdj3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eqNvgACf8nZ3QzmtbEhIfV8KtItb492O.UqlvUtEMQdj3",
      "resource": {
        "resourceType": "Observation",
        "id": "exbDjZSimhyOZeXAwFnu.eqNvgACf8nZ3QzmtbEhIfV8KtItb492O.UqlvUtEMQdj3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewLQH0YsPQVhbqmPzD7132g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2349-9",
              "display": "Glucose [Presence] in Urine"
            }
          ],
          "text": "Glucose, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:20:21Z",
        "issued": "2006-02-14T22:20:25Z",
        "valueQuantity": { "value": 0 },
        "referenceRange": [
          { "low": { "value": 0 }, "high": { "value": 0 }, "text": "0 - 0" }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZrhw8PwEF74jt6K-y.xcWtz.MACc.AoLyFwNYBPF4U5a3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZrhw8PwEF74jt6K-y.xcWtz.MACc.AoLyFwNYBPF4U5a3",
      "resource": {
        "resourceType": "Observation",
        "id": "eka69uezXMNh7wr6.0TAIZrhw8PwEF74jt6K-y.xcWtz.MACc.AoLyFwNYBPF4U5a3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLZaRNUq0g3pncFPb.XmOHw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2349-9",
              "display": "Glucose [Presence] in Urine"
            }
          ],
          "text": "Glucose, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:06Z",
        "valueQuantity": { "value": 0 },
        "referenceRange": [
          { "low": { "value": 0 }, "high": { "value": 0 }, "text": "0 - 0" }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nc20ivyVtziAlkeGArIWReb1DdKXTEY1SYiYBLulYGCM3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nc20ivyVtziAlkeGArIWReb1DdKXTEY1SYiYBLulYGCM3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIbH1jowqqHQNfVhgGc79nc20ivyVtziAlkeGArIWReb1DdKXTEY1SYiYBLulYGCM3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ecbsxsqbqEUYGoCYdZdXMpw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2349-9",
              "display": "Glucose [Presence] in Urine"
            }
          ],
          "text": "Glucose, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:20:20Z",
        "valueQuantity": { "value": 0 },
        "referenceRange": [
          { "low": { "value": 0 }, "high": { "value": 0 }, "text": "0 - 0" }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKed9p5Im3U7uUUDDqtMQxY5ftsr6zFfOrVWOXVcl-kZT53"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKed9p5Im3U7uUUDDqtMQxY5ftsr6zFfOrVWOXVcl-kZT53",
      "resource": {
        "resourceType": "Observation",
        "id": "e7x8ub3aGUMdcjK8ybIIKed9p5Im3U7uUUDDqtMQxY5ftsr6zFfOrVWOXVcl-kZT53",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eC-44wGlTKQjwvsYWff57ZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2349-9",
              "display": "Glucose [Presence] in Urine"
            }
          ],
          "text": "Glucose, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "Neg",
        "referenceRange": [
          { "low": { "value": 0 }, "high": { "value": 0 }, "text": "0 - 0" }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0SqkrhJELoKYhro24weHO.h.VTFYN.7vgSoq90AyYQYWoP1V3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0SqkrhJELoKYhro24weHO.h.VTFYN.7vgSoq90AyYQYWoP1V3",
      "resource": {
        "resourceType": "Observation",
        "id": "eUqbXu0xjNYxyJk6O0SqkrhJELoKYhro24weHO.h.VTFYN.7vgSoq90AyYQYWoP1V3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eVcTtimjYsPMqIcppXAeaUw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2349-9",
              "display": "Glucose [Presence] in Urine"
            }
          ],
          "text": "Glucose, Ur"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "Neg",
        "referenceRange": [
          { "low": { "value": 0 }, "high": { "value": 0 }, "text": "0 - 0" }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eqNvgACf8nZ3QzmtbEhIfV-noY-SM4HRGe-MLzDuByFu3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eqNvgACf8nZ3QzmtbEhIfV-noY-SM4HRGe-MLzDuByFu3",
      "resource": {
        "resourceType": "Observation",
        "id": "exbDjZSimhyOZeXAwFnu.eqNvgACf8nZ3QzmtbEhIfV-noY-SM4HRGe-MLzDuByFu3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewLQH0YsPQVhbqmPzD7132g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "RBC, UA" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:20:21Z",
        "issued": "2006-02-14T22:20:25Z",
        "valueString": "Negative"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.esDXo-OSu81LyPIMlgkAplgepEQ2x0ChpK06ENc--gQh3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.esDXo-OSu81LyPIMlgkAplgepEQ2x0ChpK06ENc--gQh3",
      "resource": {
        "resourceType": "Observation",
        "id": "exbDjZSimhyOZeXAwFnu.esDXo-OSu81LyPIMlgkAplgepEQ2x0ChpK06ENc--gQh3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewLQH0YsPQVhbqmPzD7132g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5778-6",
              "display": "Color of Urine"
            }
          ],
          "text": "Color, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:20:21Z",
        "issued": "2006-02-14T22:20:25Z",
        "valueString": "Yellow"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm1k2wKpBvRp5BGgvTFth19-3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm1k2wKpBvRp5BGgvTFth19-3",
      "resource": {
        "resourceType": "Observation",
        "id": "eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm1k2wKpBvRp5BGgvTFth19-3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLZaRNUq0g3pncFPb.XmOHw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5778-6",
              "display": "Color of Urine"
            }
          ],
          "text": "Color, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:06Z",
        "valueString": "Yellow"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr-274ONlhhEq9UZK4EPgzq43"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr-274ONlhhEq9UZK4EPgzq43",
      "resource": {
        "resourceType": "Observation",
        "id": "eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr-274ONlhhEq9UZK4EPgzq43",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ecbsxsqbqEUYGoCYdZdXMpw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5778-6",
              "display": "Color of Urine"
            }
          ],
          "text": "Color, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:20:20Z",
        "valueString": "Yellow"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAE840F6dwQoo80Ean9co.5d3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAE840F6dwQoo80Ean9co.5d3",
      "resource": {
        "resourceType": "Observation",
        "id": "e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAE840F6dwQoo80Ean9co.5d3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eC-44wGlTKQjwvsYWff57ZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5778-6",
              "display": "Color of Urine"
            }
          ],
          "text": "Color, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "Yellow"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjPMrTQF.LhyaTWHsTAfwSZV3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjPMrTQF.LhyaTWHsTAfwSZV3",
      "resource": {
        "resourceType": "Observation",
        "id": "eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjPMrTQF.LhyaTWHsTAfwSZV3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eVcTtimjYsPMqIcppXAeaUw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5778-6",
              "display": "Color of Urine"
            }
          ],
          "text": "Color, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "Yellow"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCNBEwVv9bFu2j8ThGn3RyNYyDlV7RxN-Uxc8cwdy2RpJ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCNBEwVv9bFu2j8ThGn3RyNYyDlV7RxN-Uxc8cwdy2RpJ3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCNBEwVv9bFu2j8ThGn3RyNYyDlV7RxN-Uxc8cwdy2RpJ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "18319-4",
              "display": "Neutrophils.vacuolated [Presence] in Blood by Light microscopy"
            }
          ],
          "text": "Vacuolated Neutrophils"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueString": "6.6",
        "referenceRange": [
          {
            "low": { "value": 1.7, "unit": "X 10E9/L" },
            "high": { "value": 7, "unit": "X 10E9/L" },
            "text": "1.7 - 7.0 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyZIbIBtqy.p-NYBYtEfiuuGPdkbIy5eK4ZzRPi79pRBi3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyZIbIBtqy.p-NYBYtEfiuuGPdkbIy5eK4ZzRPi79pRBi3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyZIbIBtqy.p-NYBYtEfiuuGPdkbIy5eK4ZzRPi79pRBi3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "18319-4",
              "display": "Neutrophils.vacuolated [Presence] in Blood by Light microscopy"
            }
          ],
          "text": "Vacuolated Neutrophils"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueString": "6.6",
        "referenceRange": [
          {
            "low": { "value": 1.7, "unit": "X 10E9/L" },
            "high": { "value": 7, "unit": "X 10E9/L" },
            "text": "1.7 - 7.0 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SZJj988Y5wLS5nZlYoYYuybJ4kT4E.pqLNIfPBHPDQpr3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SZJj988Y5wLS5nZlYoYYuybJ4kT4E.pqLNIfPBHPDQpr3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SZJj988Y5wLS5nZlYoYYuybJ4kT4E.pqLNIfPBHPDQpr3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "18319-4",
              "display": "Neutrophils.vacuolated [Presence] in Blood by Light microscopy"
            }
          ],
          "text": "Vacuolated Neutrophils"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueString": "5.4",
        "referenceRange": [
          {
            "low": { "value": 1.7, "unit": "X 10E9/L" },
            "high": { "value": 7, "unit": "X 10E9/L" },
            "text": "1.7 - 7.0 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx7UR8wpQFFkrKmFGg1O1Fc9Ix03eaB2b.LyVqsL2zouY3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx7UR8wpQFFkrKmFGg1O1Fc9Ix03eaB2b.LyVqsL2zouY3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarx7UR8wpQFFkrKmFGg1O1Fc9Ix03eaB2b.LyVqsL2zouY3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "18319-4",
              "display": "Neutrophils.vacuolated [Presence] in Blood by Light microscopy"
            }
          ],
          "text": "Vacuolated Neutrophils"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueString": "8.1",
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": { "value": 1.7, "unit": "X 10E9/L" },
            "high": { "value": 7, "unit": "X 10E9/L" },
            "text": "1.7 - 7.0 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1ws0NPK0DJWhlBiDY-F25YpohN-ZYRj9pz67V5e5buYtu3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1ws0NPK0DJWhlBiDY-F25YpohN-ZYRj9pz67V5e5buYtu3",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1ws0NPK0DJWhlBiDY-F25YpohN-ZYRj9pz67V5e5buYtu3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "18319-4",
              "display": "Neutrophils.vacuolated [Presence] in Blood by Light microscopy"
            }
          ],
          "text": "Vacuolated Neutrophils"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "5.6",
        "referenceRange": [
          {
            "low": { "value": 1.7, "unit": "X 10E9/L" },
            "high": { "value": 7, "unit": "X 10E9/L" },
            "text": "1.7 - 7.0 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vt9ZFxisusjrc..g3.fpumxNEvovyS0mml0eGywhvtkC3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vt9ZFxisusjrc..g3.fpumxNEvovyS0mml0eGywhvtkC3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9Vt9ZFxisusjrc..g3.fpumxNEvovyS0mml0eGywhvtkC3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "18319-4",
              "display": "Neutrophils.vacuolated [Presence] in Blood by Light microscopy"
            }
          ],
          "text": "Vacuolated Neutrophils"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "5.0",
        "referenceRange": [
          {
            "low": { "value": 1.7, "unit": "X 10E9/L" },
            "high": { "value": 7, "unit": "X 10E9/L" },
            "text": "1.7 - 7.0 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm276n8IQLLdeId6ii1mvBL.3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm276n8IQLLdeId6ii1mvBL.3",
      "resource": {
        "resourceType": "Observation",
        "id": "eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm276n8IQLLdeId6ii1mvBL.3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLZaRNUq0g3pncFPb.XmOHw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5769-5",
              "display": "Bacteria [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "Bacteria, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:06Z",
        "valueString": "None"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr.m-jrWHhC-vB5iAy1g9HCJ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr.m-jrWHhC-vB5iAy1g9HCJ3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr.m-jrWHhC-vB5iAy1g9HCJ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ecbsxsqbqEUYGoCYdZdXMpw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5769-5",
              "display": "Bacteria [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "Bacteria, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:20:20Z",
        "valueString": "None"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAFL30.bGRgThGMbC8oMDMzp3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAFL30.bGRgThGMbC8oMDMzp3",
      "resource": {
        "resourceType": "Observation",
        "id": "e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAFL30.bGRgThGMbC8oMDMzp3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eC-44wGlTKQjwvsYWff57ZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5769-5",
              "display": "Bacteria [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "Bacteria, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "None"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjNzF7MFIbo3G.-0r3rnuH0B3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjNzF7MFIbo3G.-0r3rnuH0B3",
      "resource": {
        "resourceType": "Observation",
        "id": "eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjNzF7MFIbo3G.-0r3rnuH0B3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eVcTtimjYsPMqIcppXAeaUw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5769-5",
              "display": "Bacteria [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "Bacteria, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "None"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm14PsBXc-pD2zEkVZ3eR7Cy3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm14PsBXc-pD2zEkVZ3eR7Cy3",
      "resource": {
        "resourceType": "Observation",
        "id": "eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm14PsBXc-pD2zEkVZ3eR7Cy3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLZaRNUq0g3pncFPb.XmOHw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Mucus, UA" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:06Z",
        "valueString": "Neg"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr-kf9TMu34t6yf8p1llmIOE3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr-kf9TMu34t6yf8p1llmIOE3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr-kf9TMu34t6yf8p1llmIOE3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ecbsxsqbqEUYGoCYdZdXMpw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Mucus, UA" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:20:20Z",
        "valueString": "Neg"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAFJ7a9F2EJOuSdY5GQgu4Vw3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAFJ7a9F2EJOuSdY5GQgu4Vw3",
      "resource": {
        "resourceType": "Observation",
        "id": "e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAFJ7a9F2EJOuSdY5GQgu4Vw3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eC-44wGlTKQjwvsYWff57ZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Mucus, UA" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "None"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjNzN6jodEghF4OZY0rydv1z3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjNzN6jodEghF4OZY0rydv1z3",
      "resource": {
        "resourceType": "Observation",
        "id": "eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjNzN6jodEghF4OZY0rydv1z3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eVcTtimjYsPMqIcppXAeaUw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Mucus, UA" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "None"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm2tpqCYjt1hbMsVkSAhptZt3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm2tpqCYjt1hbMsVkSAhptZt3",
      "resource": {
        "resourceType": "Observation",
        "id": "eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm2tpqCYjt1hbMsVkSAhptZt3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLZaRNUq0g3pncFPb.XmOHw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Squam Sheeting, UA" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:06Z",
        "valueString": "0-1",
        "referenceRange": [
          { "low": { "value": 1, "unit": "/HPF" }, "text": "1 /HPF" }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr91g8qWW9ZSSK5dUTeolBLV3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr91g8qWW9ZSSK5dUTeolBLV3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr91g8qWW9ZSSK5dUTeolBLV3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ecbsxsqbqEUYGoCYdZdXMpw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Squam Sheeting, UA" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:20:20Z",
        "valueString": "0-1",
        "referenceRange": [
          { "low": { "value": 1, "unit": "/HPF" }, "text": "1 /HPF" }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAGZgFDg6BVNKs3XwKJXTS623"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAGZgFDg6BVNKs3XwKJXTS623",
      "resource": {
        "resourceType": "Observation",
        "id": "e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAGZgFDg6BVNKs3XwKJXTS623",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eC-44wGlTKQjwvsYWff57ZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Squam Sheeting, UA" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "0-1",
        "referenceRange": [
          { "low": { "value": 1, "unit": "/HPF" }, "text": "1 /HPF" }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjODGe9Jbj8.D65IppM9qtW63"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjODGe9Jbj8.D65IppM9qtW63",
      "resource": {
        "resourceType": "Observation",
        "id": "eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjODGe9Jbj8.D65IppM9qtW63",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eVcTtimjYsPMqIcppXAeaUw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Squam Sheeting, UA" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "0-1",
        "referenceRange": [
          { "low": { "value": 1, "unit": "/HPF" }, "text": "1 /HPF" }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm3ihwckQALlsM6twibrQI1f3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm3ihwckQALlsM6twibrQI1f3",
      "resource": {
        "resourceType": "Observation",
        "id": "eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm3ihwckQALlsM6twibrQI1f3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLZaRNUq0g3pncFPb.XmOHw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13945-1",
              "display": "Erythrocytes [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "RBC, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:06Z",
        "valueString": "0",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "RBC's/HPF" },
            "high": { "value": 2, "unit": "RBC's/HPF" },
            "text": "0 - 2 RBC's/HPF"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr.SSEn387qYNrgxbnY8y7N03"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr.SSEn387qYNrgxbnY8y7N03",
      "resource": {
        "resourceType": "Observation",
        "id": "eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr.SSEn387qYNrgxbnY8y7N03",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ecbsxsqbqEUYGoCYdZdXMpw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13945-1",
              "display": "Erythrocytes [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "RBC, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:20:20Z",
        "valueString": "0",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "RBC's/HPF" },
            "high": { "value": 2, "unit": "RBC's/HPF" },
            "text": "0 - 2 RBC's/HPF"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAExbOQULs8XogZipaFUMbEz3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAExbOQULs8XogZipaFUMbEz3",
      "resource": {
        "resourceType": "Observation",
        "id": "e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAExbOQULs8XogZipaFUMbEz3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eC-44wGlTKQjwvsYWff57ZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13945-1",
              "display": "Erythrocytes [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "RBC, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "0",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "RBC's/HPF" },
            "high": { "value": 2, "unit": "RBC's/HPF" },
            "text": "0 - 2 RBC's/HPF"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjPllSE0.tsj-lAqc5rrY5kT3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjPllSE0.tsj-lAqc5rrY5kT3",
      "resource": {
        "resourceType": "Observation",
        "id": "eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjPllSE0.tsj-lAqc5rrY5kT3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eVcTtimjYsPMqIcppXAeaUw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13945-1",
              "display": "Erythrocytes [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "RBC, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "0",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "RBC's/HPF" },
            "high": { "value": 2, "unit": "RBC's/HPF" },
            "text": "0 - 2 RBC's/HPF"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm23zKrC6ZeR1kg-MiMBeyNT3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm23zKrC6ZeR1kg-MiMBeyNT3",
      "resource": {
        "resourceType": "Observation",
        "id": "eka69uezXMNh7wr6.0TAIZo14i2DFnnbVULvyo5JyQm23zKrC6ZeR1kg-MiMBeyNT3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLZaRNUq0g3pncFPb.XmOHw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5821-4",
              "display": "Leukocytes [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "WBC, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:06Z",
        "valueString": "0-1",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "WBC's/HPF" },
            "high": { "value": 2, "unit": "WBC's/HPF" },
            "text": "0 - 2 WBC's/HPF"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr.nmE3Wyez2VGMp1Iyr0BYH3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr.nmE3Wyez2VGMp1Iyr0BYH3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIbH1jowqqHQNfVhgGc79nenYT4MQW-yjRvJ0hRguHr.nmE3Wyez2VGMp1Iyr0BYH3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ecbsxsqbqEUYGoCYdZdXMpw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5821-4",
              "display": "Leukocytes [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "WBC, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:20:20Z",
        "valueString": "0-1",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "WBC's/HPF" },
            "high": { "value": 2, "unit": "WBC's/HPF" },
            "text": "0 - 2 WBC's/HPF"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAFGZvtL4na1J-oDZ0S0vPNM3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAFGZvtL4na1J-oDZ0S0vPNM3",
      "resource": {
        "resourceType": "Observation",
        "id": "e7x8ub3aGUMdcjK8ybIIKebio-wCCyRsjmPuQbTmzgAFGZvtL4na1J-oDZ0S0vPNM3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eC-44wGlTKQjwvsYWff57ZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5821-4",
              "display": "Leukocytes [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "WBC, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "1-2",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "WBC's/HPF" },
            "high": { "value": 2, "unit": "WBC's/HPF" },
            "text": "0 - 2 WBC's/HPF"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjPrf.fB.TyXaGqlilGqLEBX3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjPrf.fB.TyXaGqlilGqLEBX3",
      "resource": {
        "resourceType": "Observation",
        "id": "eUqbXu0xjNYxyJk6O0Sqkrm-Vnwf2wwrbSRuukXG-pjPrf.fB.TyXaGqlilGqLEBX3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eVcTtimjYsPMqIcppXAeaUw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "5821-4",
              "display": "Leukocytes [#/area] in Urine sediment by Microscopy high power field"
            }
          ],
          "text": "WBC, Urine"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "0-1",
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "WBC's/HPF" },
            "high": { "value": 2, "unit": "WBC's/HPF" },
            "text": "0 - 2 WBC's/HPF"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e46falvtiJ3fZD4WYYQx5gqQW5VDGFVdDS8H5gCXlJ51rqG-7Y-fcDuXxca0qG.4-3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e46falvtiJ3fZD4WYYQx5gqQW5VDGFVdDS8H5gCXlJ51rqG-7Y-fcDuXxca0qG.4-3",
      "resource": {
        "resourceType": "Observation",
        "id": "e46falvtiJ3fZD4WYYQx5gqQW5VDGFVdDS8H5gCXlJ51rqG-7Y-fcDuXxca0qG.4-3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4Eud-UFRn6uA0dfzsnh05Q3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:26:06Z",
        "valueQuantity": {
          "value": 175,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 200,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 200 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBWxoeKluAbdkMY44S-5UzSlvfXmPUKY68y4gZZ5grFJXpryhkUVuWrDMCG7kbxkM3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBWxoeKluAbdkMY44S-5UzSlvfXmPUKY68y4gZZ5grFJXpryhkUVuWrDMCG7kbxkM3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBWxoeKluAbdkMY44S-5UzSlvfXmPUKY68y4gZZ5grFJXpryhkUVuWrDMCG7kbxkM3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ePq0POYKaS94UBkE6QyeZXQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e3VeK6AZWFtb7l5Tr-3QB0Q3"
        },
        "effectiveDateTime": "2007-11-23T19:43:00Z",
        "issued": "2010-05-27T14:39:26Z",
        "valueQuantity": {
          "value": 160,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 200,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 200 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/egDfTe8Ttfro99n0e.PLzgEPn7nHwLvu8BtU62LxfziHGkZJUOXaONiIlZ4-tL5mY3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/egDfTe8Ttfro99n0e.PLzgEPn7nHwLvu8BtU62LxfziHGkZJUOXaONiIlZ4-tL5mY3",
      "resource": {
        "resourceType": "Observation",
        "id": "egDfTe8Ttfro99n0e.PLzgEPn7nHwLvu8BtU62LxfziHGkZJUOXaONiIlZ4-tL5mY3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eGK2VygBaD-ioEYSug7SKNA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 160,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 200,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 200 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/efZqLa2S8LHILH9odWpC.szxzocLkrW7xmYaSSvWYpoL27H466bjo6e9Ugfkv7zKI3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/efZqLa2S8LHILH9odWpC.szxzocLkrW7xmYaSSvWYpoL27H466bjo6e9Ugfkv7zKI3",
      "resource": {
        "resourceType": "Observation",
        "id": "efZqLa2S8LHILH9odWpC.szxzocLkrW7xmYaSSvWYpoL27H466bjo6e9Ugfkv7zKI3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eQHrh3MszP6taSvdTTp.dSg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:04Z",
        "issued": "2006-02-14T22:19:07Z",
        "valueQuantity": {
          "value": 158,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 200,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 200 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eVed6wQtsoO4YHNXMMjadUDBAnYmaRenA4EZHRVyZrXCyAd.q5Pk6Lb-w.90itsKP3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eVed6wQtsoO4YHNXMMjadUDBAnYmaRenA4EZHRVyZrXCyAd.q5Pk6Lb-w.90itsKP3",
      "resource": {
        "resourceType": "Observation",
        "id": "eVed6wQtsoO4YHNXMMjadUDBAnYmaRenA4EZHRVyZrXCyAd.q5Pk6Lb-w.90itsKP3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ehsu6g35pwjBgGNqxj4ptGg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiJlN4Pb62jWsEohoUA0bFA3"
        },
        "effectiveDateTime": "2005-02-14T06:00:00Z",
        "issued": "2005-11-04T17:52:02Z",
        "valueQuantity": {
          "value": 162,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 200,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 200 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRn62f2gvJ1SVSpGCpNLdomjuz74Tz40l4A9O9nZ-7AHapvXGTCxW72ca3st6SLgs3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRn62f2gvJ1SVSpGCpNLdomjuz74Tz40l4A9O9nZ-7AHapvXGTCxW72ca3st6SLgs3",
      "resource": {
        "resourceType": "Observation",
        "id": "eRn62f2gvJ1SVSpGCpNLdomjuz74Tz40l4A9O9nZ-7AHapvXGTCxW72ca3st6SLgs3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e8KLPfEVRCShb5ThN1ojPyw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T20:30:00Z",
        "issued": "2005-11-04T17:54:16Z",
        "valueQuantity": {
          "value": 164,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 35,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 200,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "35 - 200 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e4P0cXNVqNCQAEy3O83lHeCTEjH.Wxmljg.ymuN0s9Y3tw9aQ4AIJqnCd3oBR20OQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e4P0cXNVqNCQAEy3O83lHeCTEjH.Wxmljg.ymuN0s9Y3tw9aQ4AIJqnCd3oBR20OQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "e4P0cXNVqNCQAEy3O83lHeCTEjH.Wxmljg.ymuN0s9Y3tw9aQ4AIJqnCd3oBR20OQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eaGrrrRhNipyoS-JW5YCjXQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T23:20:16Z",
        "issued": "2005-10-22T23:20:25Z",
        "valueQuantity": {
          "value": 160,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 40,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 200,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "40 - 200 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ekX0lytcSqyi9C5WuVJhshPbfpj3vHdh1sNmnQmpKNX5Yri40blo.R6UKQsq2RLr83"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ekX0lytcSqyi9C5WuVJhshPbfpj3vHdh1sNmnQmpKNX5Yri40blo.R6UKQsq2RLr83",
      "resource": {
        "resourceType": "Observation",
        "id": "ekX0lytcSqyi9C5WuVJhshPbfpj3vHdh1sNmnQmpKNX5Yri40blo.R6UKQsq2RLr83",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eE5Mv0vyHb8zg3lht3sfI2A3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 155,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 40,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "40 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ec112UpEeRdZdwkoaI2f9EGBQJVcyQblA3G0OVUugg4SkQz.7c88ItUwmPdJ0aq1i3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ec112UpEeRdZdwkoaI2f9EGBQJVcyQblA3G0OVUugg4SkQz.7c88ItUwmPdJ0aq1i3",
      "resource": {
        "resourceType": "Observation",
        "id": "ec112UpEeRdZdwkoaI2f9EGBQJVcyQblA3G0OVUugg4SkQz.7c88ItUwmPdJ0aq1i3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eY0VqIHb5La3Z3ojQmQ0d0w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/exiGZVCla2tHmIX5raZ9-rQ3"
        },
        "effectiveDateTime": "1999-10-01T05:00:00Z",
        "valueQuantity": {
          "value": 155,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 40,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "40 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edsaYNxj2GuldmyQ-tYdIg-D47pDOHQL-H3rOOn6miwIWqvoUGnCmrJpdErGw.xVy3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edsaYNxj2GuldmyQ-tYdIg-D47pDOHQL-H3rOOn6miwIWqvoUGnCmrJpdErGw.xVy3",
      "resource": {
        "resourceType": "Observation",
        "id": "edsaYNxj2GuldmyQ-tYdIg-D47pDOHQL-H3rOOn6miwIWqvoUGnCmrJpdErGw.xVy3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ehHCQluwCweffaNbykSJUCw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 159,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 40,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "40 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ek1bE1ctAYp6espBg9reBhxJdLVtL18HFbx-xlbR.lvd3XLux7inaluMzjBbIU5Ur3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ek1bE1ctAYp6espBg9reBhxJdLVtL18HFbx-xlbR.lvd3XLux7inaluMzjBbIU5Ur3",
      "resource": {
        "resourceType": "Observation",
        "id": "ek1bE1ctAYp6espBg9reBhxJdLVtL18HFbx-xlbR.lvd3XLux7inaluMzjBbIU5Ur3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eBXyRMGLE2miDvhpUU8et6A3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 155,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 40,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "40 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e5Vrgx0NtoZVXAmKau.-ju0obWu7jLwQV0zsMfDQfQV4sHDGYtB4CVoHaIFRYXhds3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e5Vrgx0NtoZVXAmKau.-ju0obWu7jLwQV0zsMfDQfQV4sHDGYtB4CVoHaIFRYXhds3",
      "resource": {
        "resourceType": "Observation",
        "id": "e5Vrgx0NtoZVXAmKau.-ju0obWu7jLwQV0zsMfDQfQV4sHDGYtB4CVoHaIFRYXhds3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/es0UW1C-HAnJgqwAg9t1BEQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2571-8",
              "display": "Triglyceride [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Triglycerides"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 125,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 40,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 160,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "40 - 160 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCNBEwVv9bFu2j8ThGn3RyNbk6hNPZnn8e4lKKjXn0vD63"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCNBEwVv9bFu2j8ThGn3RyNbk6hNPZnn8e4lKKjXn0vD63",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCNBEwVv9bFu2j8ThGn3RyNbk6hNPZnn8e4lKKjXn0vD63",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "MCV" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": {
          "value": 92.1,
          "unit": "um3",
          "system": "http://unitsofmeasure.org",
          "code": "um3"
        },
        "referenceRange": [
          {
            "low": {
              "value": 80,
              "unit": "um3",
              "system": "http://unitsofmeasure.org",
              "code": "um3"
            },
            "high": {
              "value": 100,
              "unit": "um3",
              "system": "http://unitsofmeasure.org",
              "code": "um3"
            },
            "text": "80 - 100 um3"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyZIbIBtqy.p-NYBYtEfiuuEa4gnTDED0sdxFeCs9DMrO3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyZIbIBtqy.p-NYBYtEfiuuEa4gnTDED0sdxFeCs9DMrO3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyZIbIBtqy.p-NYBYtEfiuuEa4gnTDED0sdxFeCs9DMrO3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "MCV" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": {
          "value": 92.1,
          "unit": "um3",
          "system": "http://unitsofmeasure.org",
          "code": "um3"
        },
        "referenceRange": [
          {
            "low": {
              "value": 80,
              "unit": "um3",
              "system": "http://unitsofmeasure.org",
              "code": "um3"
            },
            "high": {
              "value": 100,
              "unit": "um3",
              "system": "http://unitsofmeasure.org",
              "code": "um3"
            },
            "text": "80 - 100 um3"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SZJj988Y5wLS5nZlYoYYuybYsZ.9ftitJfCPitj1J3Uk3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SZJj988Y5wLS5nZlYoYYuybYsZ.9ftitJfCPitj1J3Uk3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SZJj988Y5wLS5nZlYoYYuybYsZ.9ftitJfCPitj1J3Uk3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "MCV" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 90.9,
          "unit": "fL",
          "system": "http://unitsofmeasure.org",
          "code": "fL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 81.2,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "high": {
              "value": 95.1,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "text": "81.2 - 95.1 fL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx7UR8wpQFFkrKmFGg1O1Fc946oy8z-4nUnXUULfesOAW3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx7UR8wpQFFkrKmFGg1O1Fc946oy8z-4nUnXUULfesOAW3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarx7UR8wpQFFkrKmFGg1O1Fc946oy8z-4nUnXUULfesOAW3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "MCV" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 89.9,
          "unit": "fL",
          "system": "http://unitsofmeasure.org",
          "code": "fL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 81.2,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "high": {
              "value": 95.1,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "text": "81.2 - 95.1 fL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1ws0NPK0DJWhlBiDY-F25YprbYvvXJnFZm8zvf76TMqh63"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1ws0NPK0DJWhlBiDY-F25YprbYvvXJnFZm8zvf76TMqh63",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1ws0NPK0DJWhlBiDY-F25YprbYvvXJnFZm8zvf76TMqh63",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "MCV" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 89.9,
          "unit": "fL",
          "system": "http://unitsofmeasure.org",
          "code": "fL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 81.2,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "high": {
              "value": 95.1,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "text": "81.2 - 95.1 fL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vt9ZFxisusjrc..g3.fpumwaKC.3zzfSlMFKvWTbbAZn3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vt9ZFxisusjrc..g3.fpumwaKC.3zzfSlMFKvWTbbAZn3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9Vt9ZFxisusjrc..g3.fpumwaKC.3zzfSlMFKvWTbbAZn3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "MCV" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 85.9,
          "unit": "fL",
          "system": "http://unitsofmeasure.org",
          "code": "fL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 81.2,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "high": {
              "value": 95.1,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "text": "81.2 - 95.1 fL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e.jv8c.bg7recDgcrHHVQcZ1wHl6zG5DYkonPSqPkkuf41BRJSSXaeInZRItMm4HX3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e.jv8c.bg7recDgcrHHVQcZ1wHl6zG5DYkonPSqPkkuf41BRJSSXaeInZRItMm4HX3",
      "resource": {
        "resourceType": "Observation",
        "id": "e.jv8c.bg7recDgcrHHVQcZ1wHl6zG5DYkonPSqPkkuf41BRJSSXaeInZRItMm4HX3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/exOona88ahsxIIjCrolx-2w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "33717-0",
              "display": "Cytology Cervical or vaginal smear or scraping study"
            }
          ],
          "text": "Pap"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:17:02Z",
        "issued": "2006-02-14T22:17:05Z",
        "valueString": "Neg"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eM2-N7Yss3XtLkS7tw2hB.Z1HlrKnFJ89.CPdvEHG7w8s6OOJyVEsBqay90veihw73"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eM2-N7Yss3XtLkS7tw2hB.Z1HlrKnFJ89.CPdvEHG7w8s6OOJyVEsBqay90veihw73",
      "resource": {
        "resourceType": "Observation",
        "id": "eM2-N7Yss3XtLkS7tw2hB.Z1HlrKnFJ89.CPdvEHG7w8s6OOJyVEsBqay90veihw73",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/esSWlTEmCpjwrqreM-TLiZQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "33717-0",
              "display": "Cytology Cervical or vaginal smear or scraping study"
            }
          ],
          "text": "Pap"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:17Z",
        "valueString": "Neg"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e46falvtiJ3fZD4WYYQx5gqQW5VDGFVdDS8H5gCXlJ51wdhU6PNfl6FtCbMtlyUed3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e46falvtiJ3fZD4WYYQx5gqQW5VDGFVdDS8H5gCXlJ51wdhU6PNfl6FtCbMtlyUed3",
      "resource": {
        "resourceType": "Observation",
        "id": "e46falvtiJ3fZD4WYYQx5gqQW5VDGFVdDS8H5gCXlJ51wdhU6PNfl6FtCbMtlyUed3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4Eud-UFRn6uA0dfzsnh05Q3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e4RtxXX5-jny1-0xUyuNz9w3"
        },
        "effectiveDateTime": "2011-03-03T15:25:00Z",
        "issued": "2011-03-03T15:26:06Z",
        "valueQuantity": {
          "value": 150,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBWxoeKluAbdkMY44S-5UzSlvfXmPUKY68y4gZZ5grFKnorkakMkpd5F8Lo0nYmOH3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eBWxoeKluAbdkMY44S-5UzSlvfXmPUKY68y4gZZ5grFKnorkakMkpd5F8Lo0nYmOH3",
      "resource": {
        "resourceType": "Observation",
        "id": "eBWxoeKluAbdkMY44S-5UzSlvfXmPUKY68y4gZZ5grFKnorkakMkpd5F8Lo0nYmOH3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ePq0POYKaS94UBkE6QyeZXQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e3VeK6AZWFtb7l5Tr-3QB0Q3"
        },
        "effectiveDateTime": "2007-11-23T19:43:00Z",
        "issued": "2010-05-27T14:39:26Z",
        "valueQuantity": {
          "value": 175,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/egDfTe8Ttfro99n0e.PLzgEPn7nHwLvu8BtU62LxfziFCYRLpz8nQF6ZTd9g9d6uI3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/egDfTe8Ttfro99n0e.PLzgEPn7nHwLvu8BtU62LxfziFCYRLpz8nQF6ZTd9g9d6uI3",
      "resource": {
        "resourceType": "Observation",
        "id": "egDfTe8Ttfro99n0e.PLzgEPn7nHwLvu8BtU62LxfziFCYRLpz8nQF6ZTd9g9d6uI3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eGK2VygBaD-ioEYSug7SKNA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 194,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/efZqLa2S8LHILH9odWpC.szxzocLkrW7xmYaSSvWYpoLgry-rmoQ4tRtDUwZyci.c3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/efZqLa2S8LHILH9odWpC.szxzocLkrW7xmYaSSvWYpoLgry-rmoQ4tRtDUwZyci.c3",
      "resource": {
        "resourceType": "Observation",
        "id": "efZqLa2S8LHILH9odWpC.szxzocLkrW7xmYaSSvWYpoLgry-rmoQ4tRtDUwZyci.c3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eQHrh3MszP6taSvdTTp.dSg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:04Z",
        "issued": "2006-02-14T22:19:07Z",
        "valueQuantity": {
          "value": 198,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eVed6wQtsoO4YHNXMMjadUDBAnYmaRenA4EZHRVyZrXBMkfX3Ocbno97bKHEbM50C3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eVed6wQtsoO4YHNXMMjadUDBAnYmaRenA4EZHRVyZrXBMkfX3Ocbno97bKHEbM50C3",
      "resource": {
        "resourceType": "Observation",
        "id": "eVed6wQtsoO4YHNXMMjadUDBAnYmaRenA4EZHRVyZrXBMkfX3Ocbno97bKHEbM50C3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ehsu6g35pwjBgGNqxj4ptGg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiJlN4Pb62jWsEohoUA0bFA3"
        },
        "effectiveDateTime": "2005-02-14T06:00:00Z",
        "issued": "2005-11-04T17:52:02Z",
        "valueQuantity": {
          "value": 208,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRn62f2gvJ1SVSpGCpNLdomjuz74Tz40l4A9O9nZ-7AE4KZeMaSm5V3H0PhsRYKsL3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRn62f2gvJ1SVSpGCpNLdomjuz74Tz40l4A9O9nZ-7AE4KZeMaSm5V3H0PhsRYKsL3",
      "resource": {
        "resourceType": "Observation",
        "id": "eRn62f2gvJ1SVSpGCpNLdomjuz74Tz40l4A9O9nZ-7AE4KZeMaSm5V3H0PhsRYKsL3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e8KLPfEVRCShb5ThN1ojPyw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T20:30:00Z",
        "issued": "2005-11-04T17:54:16Z",
        "valueQuantity": {
          "value": 212,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e4P0cXNVqNCQAEy3O83lHeCTEjH.Wxmljg.ymuN0s9Y2Q-ltD3XhcqrMMQpOyTgsv3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e4P0cXNVqNCQAEy3O83lHeCTEjH.Wxmljg.ymuN0s9Y2Q-ltD3XhcqrMMQpOyTgsv3",
      "resource": {
        "resourceType": "Observation",
        "id": "e4P0cXNVqNCQAEy3O83lHeCTEjH.Wxmljg.ymuN0s9Y2Q-ltD3XhcqrMMQpOyTgsv3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eaGrrrRhNipyoS-JW5YCjXQ3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T23:20:16Z",
        "issued": "2005-10-22T23:20:25Z",
        "valueQuantity": {
          "value": 224,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ekX0lytcSqyi9C5WuVJhshPbfpj3vHdh1sNmnQmpKNX7T8P5fKlysSW-a1APwhlNh3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ekX0lytcSqyi9C5WuVJhshPbfpj3vHdh1sNmnQmpKNX7T8P5fKlysSW-a1APwhlNh3",
      "resource": {
        "resourceType": "Observation",
        "id": "ekX0lytcSqyi9C5WuVJhshPbfpj3vHdh1sNmnQmpKNX7T8P5fKlysSW-a1APwhlNh3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eE5Mv0vyHb8zg3lht3sfI2A3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 230,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ec112UpEeRdZdwkoaI2f9EGBQJVcyQblA3G0OVUugg4Sc4FksVnJZKZofGNn7Ot6.3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ec112UpEeRdZdwkoaI2f9EGBQJVcyQblA3G0OVUugg4Sc4FksVnJZKZofGNn7Ot6.3",
      "resource": {
        "resourceType": "Observation",
        "id": "ec112UpEeRdZdwkoaI2f9EGBQJVcyQblA3G0OVUugg4Sc4FksVnJZKZofGNn7Ot6.3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eY0VqIHb5La3Z3ojQmQ0d0w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/exiGZVCla2tHmIX5raZ9-rQ3"
        },
        "effectiveDateTime": "1999-10-01T05:00:00Z",
        "valueQuantity": {
          "value": 242,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edsaYNxj2GuldmyQ-tYdIg-D47pDOHQL-H3rOOn6miwKWuZSGlY3mcFSBaIX1qZxT3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/edsaYNxj2GuldmyQ-tYdIg-D47pDOHQL-H3rOOn6miwKWuZSGlY3mcFSBaIX1qZxT3",
      "resource": {
        "resourceType": "Observation",
        "id": "edsaYNxj2GuldmyQ-tYdIg-D47pDOHQL-H3rOOn6miwKWuZSGlY3mcFSBaIX1qZxT3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ehHCQluwCweffaNbykSJUCw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 262,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ek1bE1ctAYp6espBg9reBhxJdLVtL18HFbx-xlbR.lvfITiyUFw6E2cv8MnDGtVbx3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ek1bE1ctAYp6espBg9reBhxJdLVtL18HFbx-xlbR.lvfITiyUFw6E2cv8MnDGtVbx3",
      "resource": {
        "resourceType": "Observation",
        "id": "ek1bE1ctAYp6espBg9reBhxJdLVtL18HFbx-xlbR.lvfITiyUFw6E2cv8MnDGtVbx3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eBXyRMGLE2miDvhpUU8et6A3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 260,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e5Vrgx0NtoZVXAmKau.-ju0obWu7jLwQV0zsMfDQfQV7eNodLHaGDwZ3aLGVC9nnu3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e5Vrgx0NtoZVXAmKau.-ju0obWu7jLwQV0zsMfDQfQV7eNodLHaGDwZ3aLGVC9nnu3",
      "resource": {
        "resourceType": "Observation",
        "id": "e5Vrgx0NtoZVXAmKau.-ju0obWu7jLwQV0zsMfDQfQV7eNodLHaGDwZ3aLGVC9nnu3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/es0UW1C-HAnJgqwAg9t1BEQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2093-3",
              "display": "Cholesterol [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Cholesterol"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 240,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "high": {
              "value": 200,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "200 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCNBEwVv9bFu2j8ThGn3RyNYkYG6WgdtFLCciKcKFZrOc3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCNBEwVv9bFu2j8ThGn3RyNYkYG6WgdtFLCciKcKFZrOc3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCNBEwVv9bFu2j8ThGn3RyNYkYG6WgdtFLCciKcKFZrOc3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "726-0",
              "display": "Hemoglobin [Mass/volume] in Urine"
            }
          ],
          "text": "Hemoglobin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": {
          "value": 13.9,
          "unit": "g/dL",
          "system": "http://unitsofmeasure.org",
          "code": "g/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 12,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "high": {
              "value": 16,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "text": "12 - 16 g/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyZIbIBtqy.p-NYBYtEfiuuHMncz301nyBYYqhDgwridQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyZIbIBtqy.p-NYBYtEfiuuHMncz301nyBYYqhDgwridQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyZIbIBtqy.p-NYBYtEfiuuHMncz301nyBYYqhDgwridQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "726-0",
              "display": "Hemoglobin [Mass/volume] in Urine"
            }
          ],
          "text": "Hemoglobin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": {
          "value": 14.9,
          "unit": "g/dL",
          "system": "http://unitsofmeasure.org",
          "code": "g/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 13.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "high": {
              "value": 17.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "text": "13.5 - 17.5 g/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SZJj988Y5wLS5nZlYoYYuyYG.7-Xmox.kYYjBMpW3jde3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SZJj988Y5wLS5nZlYoYYuyYG.7-Xmox.kYYjBMpW3jde3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SZJj988Y5wLS5nZlYoYYuyYG.7-Xmox.kYYjBMpW3jde3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "726-0",
              "display": "Hemoglobin [Mass/volume] in Urine"
            }
          ],
          "text": "Hemoglobin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 15,
          "unit": "g/dL",
          "system": "http://unitsofmeasure.org",
          "code": "g/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 13.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "high": {
              "value": 17.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "text": "13.5 - 17.5 g/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx7UR8wpQFFkrKmFGg1O1Fc.mY192d.Csg-1QMPFdN1pw3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx7UR8wpQFFkrKmFGg1O1Fc.mY192d.Csg-1QMPFdN1pw3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarx7UR8wpQFFkrKmFGg1O1Fc.mY192d.Csg-1QMPFdN1pw3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "726-0",
              "display": "Hemoglobin [Mass/volume] in Urine"
            }
          ],
          "text": "Hemoglobin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 13.9,
          "unit": "g/dL",
          "system": "http://unitsofmeasure.org",
          "code": "g/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 13.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "high": {
              "value": 17.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "text": "13.5 - 17.5 g/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1ws0NPK0DJWhlBiDY-F25YpqJSEn-2x7Emd49AKdKxLGI3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1ws0NPK0DJWhlBiDY-F25YpqJSEn-2x7Emd49AKdKxLGI3",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1ws0NPK0DJWhlBiDY-F25YpqJSEn-2x7Emd49AKdKxLGI3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "726-0",
              "display": "Hemoglobin [Mass/volume] in Urine"
            }
          ],
          "text": "Hemoglobin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 14.4,
          "unit": "g/dL",
          "system": "http://unitsofmeasure.org",
          "code": "g/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 13.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "high": {
              "value": 17.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "text": "13.5 - 17.5 g/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vt9ZFxisusjrc..g3.fpumyz03HH2SxER2FBczPxge2G3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vt9ZFxisusjrc..g3.fpumyz03HH2SxER2FBczPxge2G3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9Vt9ZFxisusjrc..g3.fpumyz03HH2SxER2FBczPxge2G3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "726-0",
              "display": "Hemoglobin [Mass/volume] in Urine"
            }
          ],
          "text": "Hemoglobin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 14.1,
          "unit": "g/dL",
          "system": "http://unitsofmeasure.org",
          "code": "g/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 13.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "high": {
              "value": 17.5,
              "unit": "g/dL",
              "system": "http://unitsofmeasure.org",
              "code": "g/dL"
            },
            "text": "13.5 - 17.5 g/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4Aaa8RdF3SjKQ5f6Lo0yI5wdlJpbUo1cfE0lkdXvRgp.Jc3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ePdjCrNz2KcTr2Rnae.4Aaa8RdF3SjKQ5f6Lo0yI5wdlJpbUo1cfE0lkdXvRgp.Jc3",
      "resource": {
        "resourceType": "Observation",
        "id": "ePdjCrNz2KcTr2Rnae.4Aaa8RdF3SjKQ5f6Lo0yI5wdlJpbUo1cfE0lkdXvRgp.Jc3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eB5nqBicqmsZeCHplNzhy7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "17861-6",
              "display": "Calcium [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Calcium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eJ6mn3sU4bn6Eq7.DUqrXyg3"
        },
        "effectiveDateTime": "2007-11-13T04:03:32Z",
        "valueQuantity": {
          "value": 9.8,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8.8,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 10,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "8.8 - 10.0 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRH3ODQuh4LexVY0PLaPP5BJpiSicW4rhVIY2mUKIbFNS3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIiwhgwmsW8Ousqj-LmfKRH3ODQuh4LexVY0PLaPP5BJpiSicW4rhVIY2mUKIbFNS3",
      "resource": {
        "resourceType": "Observation",
        "id": "eIiwhgwmsW8Ousqj-LmfKRH3ODQuh4LexVY0PLaPP5BJpiSicW4rhVIY2mUKIbFNS3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eEEmMzRjlFj4tpgcdygAM7w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "17861-6",
              "display": "Calcium [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Calcium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:19:38Z",
        "issued": "2006-02-14T22:19:40Z",
        "valueQuantity": {
          "value": 9.2,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8.8,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 10,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "8.8 - 10.0 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuYmU.cW3wpe5ffvlghlr8HVfSmZOMjQ59JoMIgw3cc883"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eRoR7q5P-NRZBKPzyLwgnuYmU.cW3wpe5ffvlghlr8HVfSmZOMjQ59JoMIgw3cc883",
      "resource": {
        "resourceType": "Observation",
        "id": "eRoR7q5P-NRZBKPzyLwgnuYmU.cW3wpe5ffvlghlr8HVfSmZOMjQ59JoMIgw3cc883",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e4OetgbmmyJUdElq5nV0Kig3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "17861-6",
              "display": "Calcium [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Calcium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:01Z",
        "valueQuantity": {
          "value": 9.3,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8.8,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 10,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "8.8 - 10.0 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vuYAi1T.6.dhQwyqBfYzd6x3OEqmWbyZSe2Vp2EODpdp3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eKHAY5Bp-e0ZN3-OmG481vuYAi1T.6.dhQwyqBfYzd6x3OEqmWbyZSe2Vp2EODpdp3",
      "resource": {
        "resourceType": "Observation",
        "id": "eKHAY5Bp-e0ZN3-OmG481vuYAi1T.6.dhQwyqBfYzd6x3OEqmWbyZSe2Vp2EODpdp3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ezQ7IMnsWQ4LX6RkQDYtxZA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "17861-6",
              "display": "Calcium [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Calcium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:19:20Z",
        "valueQuantity": {
          "value": 9.3,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 10.1,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "8.9 - 10.1 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSO955EYLGIcRS1cKPuAvaq46nwSDDkvuyzx1pHgnC-t9B3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eG9LkyxbHz4pLMCembiWSO955EYLGIcRS1cKPuAvaq46nwSDDkvuyzx1pHgnC-t9B3",
      "resource": {
        "resourceType": "Observation",
        "id": "eG9LkyxbHz4pLMCembiWSO955EYLGIcRS1cKPuAvaq46nwSDDkvuyzx1pHgnC-t9B3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e1DmTHSh6fjZHl.iwL1UvwQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "17861-6",
              "display": "Calcium [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Calcium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 9.3,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 10.1,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "8.9 - 10.1 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x-wYzmWh.847T9oXa6vYRmgxmg4QK1xu2hehssys47ED3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/erhmvJ47wMUAuUoiBSls8x-wYzmWh.847T9oXa6vYRmgxmg4QK1xu2hehssys47ED3",
      "resource": {
        "resourceType": "Observation",
        "id": "erhmvJ47wMUAuUoiBSls8x-wYzmWh.847T9oXa6vYRmgxmg4QK1xu2hehssys47ED3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e7PspqInomYypkaM6thGHiA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "17861-6",
              "display": "Calcium [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Calcium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 9.7,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 10.1,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "8.9 - 10.1 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux.u-mlyP19aHlgj.zydDW1cTibE4bfBSe1tIy0OEhz0R3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eujnQ5OQreTwjBUPo9Cvux.u-mlyP19aHlgj.zydDW1cTibE4bfBSe1tIy0OEhz0R3",
      "resource": {
        "resourceType": "Observation",
        "id": "eujnQ5OQreTwjBUPo9Cvux.u-mlyP19aHlgj.zydDW1cTibE4bfBSe1tIy0OEhz0R3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eO1Q18BbDJFpjPnNwgTTfOw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "17861-6",
              "display": "Calcium [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Calcium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 9.6,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 10.1,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "8.9 - 10.1 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z5OFhVg8vMXQdViYQJlgT2SwP6UhauMhwkx1xYiRGU7T3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ereKB7Ir7tvrPVLzvQHf1Z5OFhVg8vMXQdViYQJlgT2SwP6UhauMhwkx1xYiRGU7T3",
      "resource": {
        "resourceType": "Observation",
        "id": "ereKB7Ir7tvrPVLzvQHf1Z5OFhVg8vMXQdViYQJlgT2SwP6UhauMhwkx1xYiRGU7T3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e6QUFcWf-6SF2tLYg7dJ.Fg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "17861-6",
              "display": "Calcium [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Calcium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e82ervAK3Xu6ba-9SyGsUCg3"
        },
        "effectiveDateTime": "1997-02-17T06:00:00Z",
        "valueQuantity": {
          "value": 9.5,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 10.1,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "8.9 - 10.1 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkCwPNDA.oZP.nBD51sdSqFIb3P8hGjK3bNaZ8IjYSl4i03"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evZrMLoPaxzj4iA7-VWIkCwPNDA.oZP.nBD51sdSqFIb3P8hGjK3bNaZ8IjYSl4i03",
      "resource": {
        "resourceType": "Observation",
        "id": "evZrMLoPaxzj4iA7-VWIkCwPNDA.oZP.nBD51sdSqFIb3P8hGjK3bNaZ8IjYSl4i03",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ec.w5K7Nw-5HefdYFkkG2WQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "17861-6",
              "display": "Calcium [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Calcium"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 9.9,
          "unit": "mg/dL",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 8.9,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "high": {
              "value": 10.1,
              "unit": "mg/dL",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dL"
            },
            "text": "8.9 - 10.1 mg/dL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCBA5Uh-lrHxLojzQKuQiSVm3gm--729jZ2iYu3r8-zT53"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCBA5Uh-lrHxLojzQKuQiSVm3gm--729jZ2iYu3r8-zT53",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCBA5Uh-lrHxLojzQKuQiSVm3gm--729jZ2iYu3r8-zT53",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "32623-1",
              "display": "Platelet mean volume [Entitic volume] in Blood by Automated count"
            }
          ],
          "text": "MPV"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": {
          "value": 9.7,
          "unit": "fL",
          "system": "http://unitsofmeasure.org",
          "code": "fL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 7.4,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "high": {
              "value": 10.9,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "text": "7.4 - 10.9 fL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyeNuW5XUiYcfnl.Q-KkdgOfPO4VugALi6z8kkYz6Thg53"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyeNuW5XUiYcfnl.Q-KkdgOfPO4VugALi6z8kkYz6Thg53",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyeNuW5XUiYcfnl.Q-KkdgOfPO4VugALi6z8kkYz6Thg53",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "32623-1",
              "display": "Platelet mean volume [Entitic volume] in Blood by Automated count"
            }
          ],
          "text": "MPV"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": {
          "value": 9.7,
          "unit": "fL",
          "system": "http://unitsofmeasure.org",
          "code": "fL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 7.6,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "high": {
              "value": 10.8,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "text": "7.6 - 10.8 fL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eiyGx4A59ZxQ5wt.u3bhNNIdiUMBa-LXJ5K7E-7d3WJ03"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eiyGx4A59ZxQ5wt.u3bhNNIdiUMBa-LXJ5K7E-7d3WJ03",
      "resource": {
        "resourceType": "Observation",
        "id": "exbDjZSimhyOZeXAwFnu.eiyGx4A59ZxQ5wt.u3bhNNIdiUMBa-LXJ5K7E-7d3WJ03",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewLQH0YsPQVhbqmPzD7132g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Cortisol, 24H Ur" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:20:21Z",
        "issued": "2006-02-14T22:20:25Z",
        "valueQuantity": { "value": 5.5 },
        "referenceRange": [
          {
            "low": { "value": 4.5 },
            "high": { "value": 8 },
            "text": "4.5 - 8.0"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCO4u35d0OoMrkJ2wbM58vZ3G7O3oMFCtYWMTW7sN3MoU3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCO4u35d0OoMrkJ2wbM58vZ3G7O3oMFCtYWMTW7sN3MoU3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCO4u35d0OoMrkJ2wbM58vZ3G7O3oMFCtYWMTW7sN3MoU3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "ACHE RBC" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": { "value": 4.35, "unit": "X 10E12/L" },
        "referenceRange": [
          {
            "low": { "value": 3.9, "unit": "X 10E12/L" },
            "high": { "value": 5.03, "unit": "X 10E12/L" },
            "text": "3.90 - 5.03 X 10E12/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyZg3Dp.6BlvFmO.zt5xi-gnjWi2oQJeUl.ClmnQEfyD93"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyZg3Dp.6BlvFmO.zt5xi-gnjWi2oQJeUl.ClmnQEfyD93",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyZg3Dp.6BlvFmO.zt5xi-gnjWi2oQJeUl.ClmnQEfyD93",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "ACHE RBC" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": { "value": 5.22, "unit": "X 10E12/L" },
        "referenceRange": [
          {
            "low": { "value": 4.32, "unit": "X 10E12/L" },
            "high": { "value": 5.72, "unit": "X 10E12/L" },
            "text": "4.32 - 5.72 X 10E12/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SWvMTZRq3lJGbDBop9ktLCu64.WGKMVM1KUmxTQFxg9p3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SWvMTZRq3lJGbDBop9ktLCu64.WGKMVM1KUmxTQFxg9p3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SWvMTZRq3lJGbDBop9ktLCu64.WGKMVM1KUmxTQFxg9p3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "ACHE RBC" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": { "value": 5.01, "unit": "X 10E12/L" },
        "referenceRange": [
          {
            "low": { "value": 4.32, "unit": "X 10E12/L" },
            "high": { "value": 5.72, "unit": "X 10E12/L" },
            "text": "4.32 - 5.72 X 10E12/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx3IlFZEe0wmEwz5Wca1cC1nQUs2UvUEPRGW0bwaDI3043"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx3IlFZEe0wmEwz5Wca1cC1nQUs2UvUEPRGW0bwaDI3043",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarx3IlFZEe0wmEwz5Wca1cC1nQUs2UvUEPRGW0bwaDI3043",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "ACHE RBC" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": { "value": 4.42, "unit": "X 10E12/L" },
        "referenceRange": [
          {
            "low": { "value": 4.32, "unit": "X 10E12/L" },
            "high": { "value": 5.72, "unit": "X 10E12/L" },
            "text": "4.32 - 5.72 X 10E12/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wuNBT.pfaXzkfDPcRORlN0pCyrZfDaa7LiMwq42jfqSP3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wuNBT.pfaXzkfDPcRORlN0pCyrZfDaa7LiMwq42jfqSP3",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1wuNBT.pfaXzkfDPcRORlN0pCyrZfDaa7LiMwq42jfqSP3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "ACHE RBC" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": { "value": 4.67, "unit": "X 10E12/L" },
        "referenceRange": [
          {
            "low": { "value": 4.32, "unit": "X 10E12/L" },
            "high": { "value": 5.72, "unit": "X 10E12/L" },
            "text": "4.32 - 5.72 X 10E12/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VqOKwOMNqfEpZADOU0fiNanqJIw-Qx6L8BRDefJDkH5Q3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VqOKwOMNqfEpZADOU0fiNanqJIw-Qx6L8BRDefJDkH5Q3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9VqOKwOMNqfEpZADOU0fiNanqJIw-Qx6L8BRDefJDkH5Q3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "ACHE RBC" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": { "value": 4.56, "unit": "X 10E12/L" },
        "referenceRange": [
          {
            "low": { "value": 4.32, "unit": "X 10E12/L" },
            "high": { "value": 5.72, "unit": "X 10E12/L" },
            "text": "4.32 - 5.72 X 10E12/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eoU8W-DXz-sv-0PUy8irqXn3kxrehkHzOmimBZHhvFuN3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.eoU8W-DXz-sv-0PUy8irqXn3kxrehkHzOmimBZHhvFuN3",
      "resource": {
        "resourceType": "Observation",
        "id": "exbDjZSimhyOZeXAwFnu.eoU8W-DXz-sv-0PUy8irqXn3kxrehkHzOmimBZHhvFuN3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewLQH0YsPQVhbqmPzD7132g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Bilirubin Urine" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:20:21Z",
        "issued": "2006-02-14T22:20:25Z",
        "valueQuantity": {
          "value": 0.02,
          "unit": "mg/dl",
          "system": "http://unitsofmeasure.org",
          "code": "mg/dl"
        },
        "referenceRange": [
          {
            "low": {
              "value": 0,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "high": {
              "value": 0.02,
              "unit": "mg/dl",
              "system": "http://unitsofmeasure.org",
              "code": "mg/dl"
            },
            "text": "0 - 0.02 mg/dl"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.es2hbN4ryBpnUmdLv.S43uveJXDK3TllWVf.F54EEWHn3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.es2hbN4ryBpnUmdLv.S43uveJXDK3TllWVf.F54EEWHn3",
      "resource": {
        "resourceType": "Observation",
        "id": "exbDjZSimhyOZeXAwFnu.es2hbN4ryBpnUmdLv.S43uveJXDK3TllWVf.F54EEWHn3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewLQH0YsPQVhbqmPzD7132g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13655-6",
              "display": "Leukocytes [Presence] in Stool by Light microscopy"
            }
          ],
          "text": "Fecal Leukocytes"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:20:21Z",
        "issued": "2006-02-14T22:20:25Z",
        "valueQuantity": { "value": 1, "unit": "cells" },
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "cells" },
            "high": { "value": 4, "unit": "cells" },
            "text": "0 - 4 cells"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCIPRSnovY2kkoqoqAjvHFSemvaM6MJvPMrr8gxnI8cEJ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCIPRSnovY2kkoqoqAjvHFSemvaM6MJvPMrr8gxnI8cEJ3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCIPRSnovY2kkoqoqAjvHFSemvaM6MJvPMrr8gxnI8cEJ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13655-6",
              "display": "Leukocytes [Presence] in Stool by Light microscopy"
            }
          ],
          "text": "Fecal Leukocytes"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": { "value": 8.8, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 3.5, "unit": "X 10E9/L" },
            "high": { "value": 10.5, "unit": "X 10E9/L" },
            "text": "3.5 - 10.5 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EydiOPIM76l13FqyPy.T7sc9HXmtCUHWS-jCC0NOHto133"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EydiOPIM76l13FqyPy.T7sc9HXmtCUHWS-jCC0NOHto133",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EydiOPIM76l13FqyPy.T7sc9HXmtCUHWS-jCC0NOHto133",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13655-6",
              "display": "Leukocytes [Presence] in Stool by Light microscopy"
            }
          ],
          "text": "Fecal Leukocytes"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": { "value": 8.8, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 3.5, "unit": "X 10E9/L" },
            "high": { "value": 10.5, "unit": "X 10E9/L" },
            "text": "3.5 - 10.5 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SbAd8rtEx7N0hd-xCIR2vIdjvZG8mAgHVfvzDBmdtTrt3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SbAd8rtEx7N0hd-xCIR2vIdjvZG8mAgHVfvzDBmdtTrt3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SbAd8rtEx7N0hd-xCIR2vIdjvZG8mAgHVfvzDBmdtTrt3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13655-6",
              "display": "Leukocytes [Presence] in Stool by Light microscopy"
            }
          ],
          "text": "Fecal Leukocytes"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": { "value": 7.8, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 3.5, "unit": "X 10E9/L" },
            "high": { "value": 10.5, "unit": "X 10E9/L" },
            "text": "3.5 - 10.5 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarxzO0MqWP2KHwFyUDVTSOzXEMr2sDLfoXcN8GJVvp8ozL3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarxzO0MqWP2KHwFyUDVTSOzXEMr2sDLfoXcN8GJVvp8ozL3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarxzO0MqWP2KHwFyUDVTSOzXEMr2sDLfoXcN8GJVvp8ozL3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13655-6",
              "display": "Leukocytes [Presence] in Stool by Light microscopy"
            }
          ],
          "text": "Fecal Leukocytes"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": { "value": 11.2, "unit": "X 10E9/L" },
        "interpretation": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/ValueSet/observation-interpretation",
              "code": "A",
              "display": "Abnormal"
            }
          ],
          "text": "Abnormal"
        },
        "referenceRange": [
          {
            "low": { "value": 3.5, "unit": "X 10E9/L" },
            "high": { "value": 10.5, "unit": "X 10E9/L" },
            "text": "3.5 - 10.5 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wpC9rXJlzyyPdNT00D13aDCPABHDk55wxtOcr3KUw7pQ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wpC9rXJlzyyPdNT00D13aDCPABHDk55wxtOcr3KUw7pQ3",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1wpC9rXJlzyyPdNT00D13aDCPABHDk55wxtOcr3KUw7pQ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13655-6",
              "display": "Leukocytes [Presence] in Stool by Light microscopy"
            }
          ],
          "text": "Fecal Leukocytes"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": { "value": 7.7, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 3.5, "unit": "X 10E9/L" },
            "high": { "value": 10.5, "unit": "X 10E9/L" },
            "text": "3.5 - 10.5 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VobkzbFJV-45WUjwHNY-7yLAxulNdm.PqH5tph9PEW5O3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VobkzbFJV-45WUjwHNY-7yLAxulNdm.PqH5tph9PEW5O3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9VobkzbFJV-45WUjwHNY-7yLAxulNdm.PqH5tph9PEW5O3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "13655-6",
              "display": "Leukocytes [Presence] in Stool by Light microscopy"
            }
          ],
          "text": "Fecal Leukocytes"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": { "value": 6.9, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 3.5, "unit": "X 10E9/L" },
            "high": { "value": 10.5, "unit": "X 10E9/L" },
            "text": "3.5 - 10.5 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCIPRSnovY2kkoqoqAjvHFSfnfrgTzy5HxGMq-wf9MBOZ3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCIPRSnovY2kkoqoqAjvHFSfnfrgTzy5HxGMq-wf9MBOZ3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCIPRSnovY2kkoqoqAjvHFSfnfrgTzy5HxGMq-wf9MBOZ3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "10328-3",
              "display": "Lymphocytes/100 leukocytes in Cerebral spinal fluid by Manual count"
            }
          ],
          "text": "Lymphs, CSF"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": { "value": 1.7, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.9, "unit": "X 10E9/L" },
            "high": { "value": 2.9, "unit": "X 10E9/L" },
            "text": "0.9 - 2.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EydiOPIM76l13FqyPy.T7sc8s8iWofIRmnbHYc84xJImB3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EydiOPIM76l13FqyPy.T7sc8s8iWofIRmnbHYc84xJImB3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EydiOPIM76l13FqyPy.T7sc8s8iWofIRmnbHYc84xJImB3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "10328-3",
              "display": "Lymphocytes/100 leukocytes in Cerebral spinal fluid by Manual count"
            }
          ],
          "text": "Lymphs, CSF"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": { "value": 1.7, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.9, "unit": "X 10E9/L" },
            "high": { "value": 2.9, "unit": "X 10E9/L" },
            "text": "0.9 - 2.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SbAd8rtEx7N0hd-xCIR2vIciPjyZm1DuclOGgf8pS42T3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SbAd8rtEx7N0hd-xCIR2vIciPjyZm1DuclOGgf8pS42T3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SbAd8rtEx7N0hd-xCIR2vIciPjyZm1DuclOGgf8pS42T3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "10328-3",
              "display": "Lymphocytes/100 leukocytes in Cerebral spinal fluid by Manual count"
            }
          ],
          "text": "Lymphs, CSF"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": { "value": 1.2, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.9, "unit": "X 10E9/L" },
            "high": { "value": 2.9, "unit": "X 10E9/L" },
            "text": "0.9 - 2.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarxzO0MqWP2KHwFyUDVTSOzXFce8BZf9-H1LDONqPPjnqc3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarxzO0MqWP2KHwFyUDVTSOzXFce8BZf9-H1LDONqPPjnqc3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarxzO0MqWP2KHwFyUDVTSOzXFce8BZf9-H1LDONqPPjnqc3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "10328-3",
              "display": "Lymphocytes/100 leukocytes in Cerebral spinal fluid by Manual count"
            }
          ],
          "text": "Lymphs, CSF"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": { "value": 1.4, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.9, "unit": "X 10E9/L" },
            "high": { "value": 2.9, "unit": "X 10E9/L" },
            "text": "0.9 - 2.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wpC9rXJlzyyPdNT00D13aDBQGPPrQ74eEjT8Xm7RMS563"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wpC9rXJlzyyPdNT00D13aDBQGPPrQ74eEjT8Xm7RMS563",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1wpC9rXJlzyyPdNT00D13aDBQGPPrQ74eEjT8Xm7RMS563",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "10328-3",
              "display": "Lymphocytes/100 leukocytes in Cerebral spinal fluid by Manual count"
            }
          ],
          "text": "Lymphs, CSF"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": { "value": 1.5, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.9, "unit": "X 10E9/L" },
            "high": { "value": 2.9, "unit": "X 10E9/L" },
            "text": "0.9 - 2.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VobkzbFJV-45WUjwHNY-7yKKHZSAkUpZ2mhhm5IlBSQw3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VobkzbFJV-45WUjwHNY-7yKKHZSAkUpZ2mhhm5IlBSQw3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9VobkzbFJV-45WUjwHNY-7yKKHZSAkUpZ2mhhm5IlBSQw3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "10328-3",
              "display": "Lymphocytes/100 leukocytes in Cerebral spinal fluid by Manual count"
            }
          ],
          "text": "Lymphs, CSF"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": { "value": 1.1, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.9, "unit": "X 10E9/L" },
            "high": { "value": 2.9, "unit": "X 10E9/L" },
            "text": "0.9 - 2.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCIPRSnovY2kkoqoqAjvHFSfPOOj0-GG6vT54Nlh3DrUF3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCIPRSnovY2kkoqoqAjvHFSfPOOj0-GG6vT54Nlh3DrUF3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCIPRSnovY2kkoqoqAjvHFSfPOOj0-GG6vT54Nlh3DrUF3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Baso, CSF" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": { "value": 0.1, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "X 10E9/L" },
            "high": { "value": 0.1, "unit": "X 10E9/L" },
            "text": "0 - 0.1 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EydiOPIM76l13FqyPy.T7sc-qz5HkZLcg7ygW.Jeuvobe3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EydiOPIM76l13FqyPy.T7sc-qz5HkZLcg7ygW.Jeuvobe3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EydiOPIM76l13FqyPy.T7sc-qz5HkZLcg7ygW.Jeuvobe3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Baso, CSF" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": { "value": 0.1, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0, "unit": "X 10E9/L" },
            "high": { "value": 0.1, "unit": "X 10E9/L" },
            "text": "0 - 0.1 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCJ-02KQCo3VKIzy5oWhW.Vu910PMVYKkuJpeC7TZkhDd3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCJ-02KQCo3VKIzy5oWhW.Vu910PMVYKkuJpeC7TZkhDd3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCJ-02KQCo3VKIzy5oWhW.Vu910PMVYKkuJpeC7TZkhDd3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Monocytes" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": { "value": 0.4, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "X 10E9/L" },
            "high": { "value": 0.9, "unit": "X 10E9/L" },
            "text": "0.3 - 0.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyXhoZIVOoyIAgdrAGsISA.I1lA2MiaQciJOsAMDwnuCk3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyXhoZIVOoyIAgdrAGsISA.I1lA2MiaQciJOsAMDwnuCk3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyXhoZIVOoyIAgdrAGsISA.I1lA2MiaQciJOsAMDwnuCk3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Monocytes" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": { "value": 0.4, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "X 10E9/L" },
            "high": { "value": 0.9, "unit": "X 10E9/L" },
            "text": "0.3 - 0.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SdbUZ9O1hv8T-0GZ.Q5jdN7Rn9Mhy1sInkqodXz.ORSP3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SdbUZ9O1hv8T-0GZ.Q5jdN7Rn9Mhy1sInkqodXz.ORSP3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SdbUZ9O1hv8T-0GZ.Q5jdN7Rn9Mhy1sInkqodXz.ORSP3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Monocytes" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": { "value": 0.6, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "X 10E9/L" },
            "high": { "value": 0.9, "unit": "X 10E9/L" },
            "text": "0.3 - 0.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx5RjnJAwGjMED1R17HQRmhsx.MmTUyb1I0JbimZCuT.I3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx5RjnJAwGjMED1R17HQRmhsx.MmTUyb1I0JbimZCuT.I3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarx5RjnJAwGjMED1R17HQRmhsx.MmTUyb1I0JbimZCuT.I3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Monocytes" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": { "value": 0.5, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "X 10E9/L" },
            "high": { "value": 0.9, "unit": "X 10E9/L" },
            "text": "0.3 - 0.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1whMEdGw969zadcAnl6eOb1x12VGtjJohfJ1hQuZtj5kd3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1whMEdGw969zadcAnl6eOb1x12VGtjJohfJ1hQuZtj5kd3",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1whMEdGw969zadcAnl6eOb1x12VGtjJohfJ1hQuZtj5kd3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Monocytes" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": { "value": 0.6, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "X 10E9/L" },
            "high": { "value": 0.9, "unit": "X 10E9/L" },
            "text": "0.3 - 0.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vj3m4wzhMS4EdLJqtsa0HZQFzbAzcdrVveKy1BvLnXgl3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vj3m4wzhMS4EdLJqtsa0HZQFzbAzcdrVveKy1BvLnXgl3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9Vj3m4wzhMS4EdLJqtsa0HZQFzbAzcdrVveKy1BvLnXgl3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Monocytes" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": { "value": 0.4, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 0.3, "unit": "X 10E9/L" },
            "high": { "value": 0.9, "unit": "X 10E9/L" },
            "text": "0.3 - 0.9 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCJ-02KQCo3VKIzy5oWhW.Vu10ftKdzuwD6UJ9I72-YYV3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCJ-02KQCo3VKIzy5oWhW.Vu10ftKdzuwD6UJ9I72-YYV3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCJ-02KQCo3VKIzy5oWhW.Vu10ftKdzuwD6UJ9I72-YYV3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": { "value": 411, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyXhoZIVOoyIAgdrAGsISA.LrC2PcHbpZE5L3mkyy3-QN3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyXhoZIVOoyIAgdrAGsISA.LrC2PcHbpZE5L3mkyy3-QN3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyXhoZIVOoyIAgdrAGsISA.LrC2PcHbpZE5L3mkyy3-QN3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": { "value": 411, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SdbUZ9O1hv8T-0GZ.Q5jdN4hmNL-gxXbfMZLfAJtBGvL3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SdbUZ9O1hv8T-0GZ.Q5jdN4hmNL-gxXbfMZLfAJtBGvL3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SdbUZ9O1hv8T-0GZ.Q5jdN4hmNL-gxXbfMZLfAJtBGvL3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": { "value": 432, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx5RjnJAwGjMED1R17HQRmhuBEBVGmVQgpGCOdS3VrDsR3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx5RjnJAwGjMED1R17HQRmhuBEBVGmVQgpGCOdS3VrDsR3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarx5RjnJAwGjMED1R17HQRmhuBEBVGmVQgpGCOdS3VrDsR3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": { "value": 401, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1whMEdGw969zadcAnl6eOb1ybKb0RU8EU8SBfJP2z5K273"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1whMEdGw969zadcAnl6eOb1ybKb0RU8EU8SBfJP2z5K273",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1whMEdGw969zadcAnl6eOb1ybKb0RU8EU8SBfJP2z5K273",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": { "value": 399, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vj3m4wzhMS4EdLJqtsa0HZQNVzfrqe7RFKs8zYcQncJd3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vj3m4wzhMS4EdLJqtsa0HZQNVzfrqe7RFKs8zYcQncJd3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9Vj3m4wzhMS4EdLJqtsa0HZQNVzfrqe7RFKs8zYcQncJd3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": { "value": 375, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.etyK-AFa1tP7.hCFr52S0l.QIHPPVHaaV1h0Xw0uW6Re3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/exbDjZSimhyOZeXAwFnu.etyK-AFa1tP7.hCFr52S0l.QIHPPVHaaV1h0Xw0uW6Re3",
      "resource": {
        "resourceType": "Observation",
        "id": "exbDjZSimhyOZeXAwFnu.etyK-AFa1tP7.hCFr52S0l.QIHPPVHaaV1h0Xw0uW6Re3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewLQH0YsPQVhbqmPzD7132g3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Appearance" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ev2.RLOGYuJFtn3GJ-4KI-g3"
        },
        "effectiveDateTime": "2006-02-14T22:20:21Z",
        "issued": "2006-02-14T22:20:25Z",
        "valueString": "Clear"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZsMBVaS5v-JfNd5MhEwIzv2NN43lT4YgD2Z8BXHHtFZR3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eka69uezXMNh7wr6.0TAIZsMBVaS5v-JfNd5MhEwIzv2NN43lT4YgD2Z8BXHHtFZR3",
      "resource": {
        "resourceType": "Observation",
        "id": "eka69uezXMNh7wr6.0TAIZsMBVaS5v-JfNd5MhEwIzv2NN43lT4YgD2Z8BXHHtFZR3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLZaRNUq0g3pncFPb.XmOHw3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Appearance" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:30:06Z",
        "valueString": "Clear"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nWQTMK4dFysstcSdh-ChrwPbzkqJUpakS9kExs0Jx6A93"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eIbH1jowqqHQNfVhgGc79nWQTMK4dFysstcSdh-ChrwPbzkqJUpakS9kExs0Jx6A93",
      "resource": {
        "resourceType": "Observation",
        "id": "eIbH1jowqqHQNfVhgGc79nWQTMK4dFysstcSdh-ChrwPbzkqJUpakS9kExs0Jx6A93",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ecbsxsqbqEUYGoCYdZdXMpw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Appearance" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:20:20Z",
        "valueString": "Clear"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKeR0nWXRVK1mSFZBfMGPVYZgxSSzLh00kdba9iGUnQBbt3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e7x8ub3aGUMdcjK8ybIIKeR0nWXRVK1mSFZBfMGPVYZgxSSzLh00kdba9iGUnQBbt3",
      "resource": {
        "resourceType": "Observation",
        "id": "e7x8ub3aGUMdcjK8ybIIKeR0nWXRVK1mSFZBfMGPVYZgxSSzLh00kdba9iGUnQBbt3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eC-44wGlTKQjwvsYWff57ZQ3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Appearance" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueString": "Clear"
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0SqkrvOydVWnfo3QQuD5fiADkKP5vrE9e.-ljeDN9LZ0Uoit3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eUqbXu0xjNYxyJk6O0SqkrvOydVWnfo3QQuD5fiADkKP5vrE9e.-ljeDN9LZ0Uoit3",
      "resource": {
        "resourceType": "Observation",
        "id": "eUqbXu0xjNYxyJk6O0SqkrvOydVWnfo3QQuD5fiADkKP5vrE9e.-ljeDN9LZ0Uoit3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eVcTtimjYsPMqIcppXAeaUw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": { "text": "Appearance" },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueString": "Clear"
      },
      "search": { "mode": "match" }
    },
    {
      "resource": {
        "resourceType": "OperationOutcome",
        "issue": [
          {
            "severity": "warning",
            "code": "processing",
            "details": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.13.0.1.7.2.657369",
                  "code": "4119",
                  "display": "This response includes information available to the authorized user at the time of the request. It may not contain the entire record available in the system."
                }
              ],
              "text": "This response includes information available to the authorized user at the time of the request. It may not contain the entire record available in the system."
            }
          }
        ]
      },
      "search": { "mode": "outcome" }
    }
  ]
}
